import React from 'react'

import { withRouter } from 'react-router-dom'

import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button'
import { Editor } from "primereact/editor";
import { Steps } from 'primereact/steps';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { MultiSelect } from 'primereact/multiselect'
import { InputText } from 'primereact/inputtext'
import { InputMask } from 'primereact/inputmask';
import { InputNumber } from 'primereact/inputnumber'
import { AutoComplete } from 'primereact/autocomplete';
import { InputTextarea } from 'primereact/inputtextarea'
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar'
import { TabView, TabPanel } from 'primereact/tabview';
import { Accordion, AccordionTab } from 'primereact/accordion'
import { locale, addLocale, updateLocaleOption, updateLocaleOptions, localeOption, localeOptions } from 'primereact/api'
import { RadioButton } from 'primereact/radiobutton'
import { Checkbox } from 'primereact/checkbox'
import { SelectButton } from 'primereact/selectbutton'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { uniqueId } from "lodash"
import filesize from 'filesize'

import NavBar from '../../componentes/Navbar'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList/index'

import PessoaService from '../../app/service/PessoaService'
import LocalStorageService from '../../app/service/localStorageService'
import GrupoPessoasUsuariosService from '../../app/service/GrupoPessoasUsuariosService'
import EstadoService from '../../app/service/EstadoService'
import CidadeService from '../../app/service/CidadeService'
import UploadPessoaService from '../../app/service/UploadPessoaService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import AtendimentoService from '../../app/service/AtendimentoService'
import HistoricoPessoaService from '../../app/service/HistoricoPessoaService'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import AtividadeService from '../../app/service/AtividadeService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import UsuarioGruposTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import TipoBeneficioService from '../../app/service/TipoBeneficioService'
import VinculoPrevidenciarioService from '../../app/service/VinculoPrevidenciarioService'
import CalculoTipoContribuicaoService from '../../app/service/CalculoTipoContribuicaoService'

import Logo from '../../pages/seguranca/img/kleiton.JPG'
import './pessoa.css'

class ConsultarPessoa extends React.Component {
  constructor(props) {
    super(props);

    this.pessoaService = new PessoaService();
    this.grupoPessoaUsuariosService = new GrupoPessoasUsuariosService();
    this.estadoService = new EstadoService();
    this.cidadeService = new CidadeService();
    this.uploadPessoaService = new UploadPessoaService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.atendimentoService = new AtendimentoService();
    this.historicoPessoaService = new HistoricoPessoaService();
    this.atividadeService = new AtividadeService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.usuarioGrupoTrabalhoService = new UsuarioGruposTrabalhoService();
    this.tipoBeneficioService = new TipoBeneficioService();
    this.vinculoPrevidenciarioService = new VinculoPrevidenciarioService();
    this.calculoService = new CalculoTipoContribuicaoService();

    this.onTipoPessoaChange = this.onTipoPessoaChange.bind(this);
    this.onChangePerfil = this.onChangePerfil.bind(this);
    this.onChangeEstadoCivil = this.onChangeEstadoCivil.bind(this);
    this.onChangeTipoEndereco = this.onChangeTipoEndereco.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeCidade = this.onChangeCidade.bind(this);
    this.onChangeEstadoCivil = this.onChangeEstadoCivil.bind(this);
    this.onChangeTipoPessoa = this.onChangeTipoPessoa.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.acoesProcessos = this.acoesProcessos.bind(this);
    this.onChangeTipoConta = this.onChangeTipoConta.bind(this);
    this.acoesHistorico = this.acoesHistorico.bind(this);
    this.renderFooterDescricaoArquivo = this.renderFooterDescricaoArquivo.bind(this);
    this.onChangeCaptador = this.onChangeCaptador.bind(this);
    this.onChangeGrupoPessoas = this.onChangeGrupoPessoas.bind(this);
    this.renderFooterHistorico = this.renderFooterHistorico.bind(this);
    this.acceptExcluirHistorico = this.acceptExcluirHistorico.bind(this);
    this.statusTemplate = this.statusTemplate.bind(this);
    this.linkConsultarAtividade = this.linkConsultarAtividade.bind(this);
    this.prazoFatal = this.prazoFatal.bind(this);
    this.templateHistoricoAtividade = this.templateHistoricoAtividade.bind(this);
    this.onGrupoTrabalhoUsuariosAtivosChange = this.onGrupoTrabalhoUsuariosAtivosChange.bind(this);
    this.onGrauChange = this.onGrauChange.bind(this);
    this.acoesVinculosPrevidenciarios = this.acoesVinculosPrevidenciarios.bind(this);
    this.acoesCalculosTipoContribuicao = this.acoesCalculosTipoContribuicao.bind(this);

    this.state = {
      pessoa: null,
      codigo: '',
      statusPessoa: null,
      nome: '',
      labelNome: '',
      tipoPessoa: null,
      perfil: null,
      perfis: [],
      dataNascimento: '',
      profissao: '',
      atividadeEconomica: '',
      estadoCivil: null,
      estadosCivil: [],
      cpfCnpj: '',
      rg: '',
      passaporte: '',
      tituloEleitor: '',
      reservista: '',
      pis: '',
      cnh: '',
      ctps: '',
      nomeMae: '',
      nomePai: '',
      naturalidade: '',
      nacionalidade: '',
      email: '',
      telefone1: '',
      telefone2: '',
      endereco: '',
      numero: '',
      tipoEndereco: null,
      tiposEndereco: [],
      bairro: '',
      cep: '',
      estado: null,
      estados: [],
      cidade: null,
      cidades: [],
      contaCorrente: '',
      tipoConta: '',
      agencia: '',
      banco: '',
      pix: '',
      observacao: '',
      status: '',
      classeDiv: '',
      detail: '',
      defineTipoPessoa: {},
      defineTipoPessoaJuridica: {},
      processos: [],
      //Arquivos
      upLoadFiles: [],
      nome: '',
      descricao: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
      captadores: [],
      captador: null,
      grupoPessoas: [],
      grupoCliente: null,
      //Atendimentos
      atendimentos: [],
      openSpinner: false,
      //Hitórico de Pessoas
      historico: [],
      modalHistorico: false,
      descricaoHistorico: '',
      dataCadastro: '',
      dataUltimaAlteracao: '',
      codigoHistorico: '',
      //Atividades por pessoa
      atividades:[],
      atividde: null,
      modalAtividade: false,
      //Alterar Atividade
      atividade: null,
      codigoAtividade: '',
      codigoProcesso: '',
      tituloAtividade: '',
      pontuacao: '',
      usuarioCriouAtividade: '',
      dataRegisroAtividade: '',
      descricaoAtividade: '',
      grupoTrabalhoDescricao: '',
      subGrupoTrabalhoDescricao: '',
      codigoSubGrupo: '',
      codigoGrupo: '',
      tipoAtividade: null,
      horaAntiga: '',
      hora: '',
      dataLimiteAntiga: '',
      dtLimite: '',
      dtFatal: '',
      statusCodigo: '',
      status: null,
      statusAtividade: [],
      grau: [],
      responsaveisLista: [],
      quantidadeResponsaveis: '',
      responsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      interessados: '',
      descricaoStatus: '',
      displayAtividade: false,
      pessoa: null,
      campoPessoaPesquisada: 'none',
      pessoaPesquisada: '',
      historicoAtividades: [],
      linkLancamento: 'none',
      //Hitórico da Atividade
      dsHistoricoAtividade: '',
      historicoAtividade: null,
      modalAlterarHistorico: false,
      displayHistoricoIncluir: false,
      registroHistorico: null,
      //Nova Atividade
      modalNovaAtividade: false,
      titulosAtividade: [],
      tituloAtividde: null,
      gruposTrabalho: [],
      grupoTrabalho: null,
      subGruposTrabalho: [],
      subGrupoTrabalho: null,
      //Módulo Previdenciário
      numeroBeneficio: '',
      tiposBeneficios: [],
      tipoBeneficio: null,
      senhaCliente: '',
      dataEntradaRequerimento: '',
      dataInicioBeneficio: '',
      dataCessacaoBeneficio: '',
      dataUltimaContribuicao: '',
      tempoContribuicaoAnos: '',
      tempoContribuicaoMeses: '',
      idadeDataEntradaRequerimento: '',
      //Vínculo Previdenciário
      codigoVinculo: '',
      vinculoPrevidenciario: [],
      vinculoPrevidenciarioRegistro: null,
      cpfCnpjEmpregador: '',
      empregador: '',
      periodoVinculoInicial: '',
      periodoVinculoFinal: '',
      tipoContribuicao: null,
      snEspecialVinculo: null,
      modalVinculoPrevidenciario: false,
      modalVinculoPrevidenciarioAlterar: false,
      //Cálculo por tipo de contribuição
      calculos: [],
      calculo: null,
      codigoCalculo: '',
      dataBaseCalculo: '',
      anosComum: '',
      mesesComum: '',
      diasComum: '',
      anosEspecial: '',
      mesesEspecial: '',
      diasEspecial: '',
      anosTotal: '',
      mesesTotal: '',
      diasTotal: '',
      fatorPrevidenciario: '',
      simulacaoResultado: '',
      tipoAposentadoria: null,
      modalCalculo: false,
      modalCalculoAlterar: false,
    };

    this.tipoPessoa = [
      {codigo: 'F', nome: 'Física'},
      {codigo: 'J', nome: 'Jurídica'}
    ];

    this.status = [
      {codigo: '0', nome: 'Ativo'},
      {codigo: '1', nome: 'Inativo'}
    ];

    this.conta = [
      {codigo: 'C', nome: 'Conta Corrente'},
      {codigo: 'P', nome: 'Poupança'}
    ]

    this.tipoContribuicao = [
      {codigo:'EMPREGADO_CLT',nome:'Empregado CLT'},
      {codigo:'CONTRIBUINTE_INDIVIDUAL',nome:'Contribuinte Individual'},
      {codigo: 'FACULTATIVO',nome:'Facultativo'},
      {codigo: 'DOMESTICO',nome: 'Doméstico'},
      {codigo: 'AVULSO', nome: 'Avulso'},
      {codigo: 'SERVIDOR_PUBLICO', nome: 'Servidor Público'},
      {codigo: 'MILITAR', nome: 'Militar'},
      {codigo: 'RURAL', nome: 'Rural'},
      {codigo: 'SEGURADO_ESPECIAL', nome: 'Segurado Especial'},
      {codigo: 'TEMPO_NAO_CONTRIBUTIVO', nome: 'Tempo Não Contribuído'}
    ];

    this.especialContribuicao = [
      {codigo: 'S', nome: 'SIM'},
      {codigo: 'N', nome: 'NÃO'}
    ];

    this.tipoAposentadoria = [
      {codigo: 'POR_IDADE',nome: 'Por Idade'},
      {codigo: 'POR_TEMPO_CONTRIBUICAO',nome: 'Por Tempo de Contribuição'},
      {codigo: 'POR_PONTOS', nome: 'Por Pontos'},
      {codigo: 'ESPECIAL', nome: 'Especial'},
      {codigo: 'POR_INVALIDEZ', nome: 'Por Invalidez'},
      {codigo: 'PONTUACAO_50', nome: 'Pontuação 50'},
      {codigo: 'PONTUACAO_100', nome: 'Pontuação 100'},
      {codigo: 'IDADE_PROGRESSIVA', nome: 'Idade Progressiva'},
      {codigo: 'RURAL', nome: 'Rural'},
      {codigo: 'PROFESSOR', nome: 'Professor'},
      {codigo: 'DEFICIENCIA', nome: 'Deficiência'}
    ];

    addLocale('es', {
      firstDayOfWeek: 1,
      dayNames: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesShort: ['Domingo', 'Domingo', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Stembro', 'Outubro', 'Novembro', 'Dezemro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      today: 'Hoy',
      clear: 'Claro'
    });
  }

  cadastrarHistoricoPessoa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.descricaoHistorico == '') {
      this.toast.show({severity:'error', summary: 'Histórico de Pessoas', detail:'Informe o histórico', life: 4000});
      return;
    }
    const historico = {
      pessoa: this.state.pessoa,
      dsHistorico: this.state.descricaoHistorico,
      usuario: usuarioLogado
    }

    this.setState({openSpinner: true});
    await this.historicoPessoaService.cadastrarHistorico(historico)
      .then(response => {
        this.listarHistoricoPessoas();
        this.toast.show({severity:'success', summary: 'Histórico de Pessoas', detail:'Histórico cadastrado com sucesso', life: 4000});
        this.fecharModalCadastro('modalHistorico');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarHistoricoPessoas = async () => {
    await this.historicoPessoaService.listarPorPessoa(this.state.pessoa.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  renderFooterHistorico(name) {
    return (
        <div>
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarHistoricoPessoa}/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
        </div>
    );
  }

  onChangeCaptador(e) {
    this.setState({captador: e.value});
  }

  listarCaptadores = () => {
    const usuarioLogado = this.context.usuarioAutenticado
    this.pessoaService.listarCaptadores('CP', usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({captadores: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  onChangeGrupoPessoas(e) {
    this.setState({grupoCliente: e.value});
  }

  listarGruposPessoas = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoPessoaUsuariosService.listarGrupos(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupoPessoas: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Cadastro de Pessoas - Consulta de Grupo de Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarAtendimentos = (pessoa) => {
    this.atendimentoService.consultarAtendimentosPorPessoa(pessoa)
      .then(response => {
        this.setState({atendimentos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesHistorico(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text" 
                tooltip="Excluir"
                onClick={() => this.confirmaExclusaoHistorico(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({codigoHistorico: historico.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir o histórico selecionado ?',
        header: 'Exclusão de histórico',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistorico,
        reject: this.reject
    });
  }

  async acceptExcluirHistorico() {
    await this.excluirHistorico();
  }

  excluirHistorico = async () => {
    this.setState({openSpinner: true});
    await this.historicoPessoaService.excluirHistorico(this.state.codigoHistorico)
      .then(response => {
        this.listarHistoricoPessoas();
        this.toast.show({severity:'success', summary: 'Exclusão de Histórico', detail:'Histórico excluído com sucesso', life: 4000});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Exclusão de Histórico', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});

  }

  consultarAtendimento(atendimento) {
    this.props.history.push(`/historicoAtendimento/${atendimento.codigo}/pessoa/${this.state.pessoa.codigo}`);    
  }

  onChangeTipoConta(e) {
    this.setState({tipoConta: e.value})
  }

  onChangeDefineTipoPessoa = () => {
    if(this.state.tipoPessoa === 'J') {
      this.setState({defineTipoPessoa: {
        display: 'none'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'block'
      }});
      this.setState({labelNome: 'Empresa'});
    } else {
      this.setState({defineTipoPessoa: {
        display: 'block'
      }});
      this.setState({defineTipoPessoaJuridica: {
        display: 'none'
      }});
      this.setState({labelNome: 'Nome'});
    }
  }

  async onChangeTipoPessoa(e) {
    await this.setState({tipoPessoa: e.value});
    this.onChangeDefineTipoPessoa();
  }

  async componentDidMount() {
    const params = this.props.match.params;
    if(params.codigo) {
      this.setState({openSpinner: true});
      await this.consultarPessoa(params.codigo);
      await this.listarTiposBeneficios();
      this.setState({openSpinner: false});
    }
  }

  listarPerfisPessoa = async () => {
    await this.pessoaService.listarPerfilPessoa()
      .then(response => {
        this.setState({perfis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de perfis de pessoa', life: 4000});
      })
  }

  onChangePerfil(e) {
    this.setState({perfil: e.value});
  }

  listarEstadosCivil = async () => {
    await this.pessoaService.listarEstadoCivil()
      .then(response => {
        this.setState({estadosCivil: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de estados civis', life: 4000});
      })
  }

  onChangeEstadoCivil(e) {
    this.setState({estadoCivil: e.value});
  }

  listarTiposEndereco = async () => {
    await this.pessoaService.listarTiposEndereco()
      .then(response => {
        this.setState({tiposEndereco: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar tipos de endereço', life: 4000});
      })
  }

  onChangeTipoEndereco(e) {
    this.setState({tipoEndereco: e.value});
  }

  onTipoPessoaChange(e) {
    this.setState({tipoPessoa: e.value});
  }

  listarEstados = async () => {
    this.estadoService.listarEstados()
      .then(response => {
        this.setState({estados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar Estados', life: 4000});
      });

      this.listarCidades();
  }

  async onChangeEstado(e) {
    await this.setState({estado: e.value});
    this.listarCidades();
  }

  listarCidades = () => {
    this.cidadeService.listarCidades(this.state.estado.codigo)
      .then(response => {
        this.setState({cidades: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Pessoas', detail:'Erro ao listar Cidades', life: 4000});
      })
  }

  onChangeCidade(e) {
    this.setState({cidade: e.value});
  }

  onChangeEstadoCivil(e) {
    this.setState({estadoCivil: e.value});
  }

  async consultarPessoa(codigo) {
    this.setState({openSpinner: true});
    await this.pessoaService.consultarPessoa(codigo)
      .then(response => {
        console.log('Pessoa ', response.data);
        this.setState({pessoa: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({nome: response.data.nome});
        if(response.data.tipoPessoa === 'F') {
          this.setState({tipoPessoa: {
            codigo: 'F', nome: 'Física'
          }});
          this.setState({defineTipoPessoa: {display: 'block'}});
          this.setState({defineTipoPessoaJuridica: {display: 'none'}});
          this.setState({labelNome: 'Nome'});
        } else {
          this.setState({tipoPessoa: {
            codigo: 'J', nome: 'Jurídica'
          }});
          this.setState({defineTipoPessoa: {display: 'none'}})
          this.setState({defineTipoPessoaJuridica: {display: 'block'}});
          this.setState({labelNome: 'Empresa'});
        }
        this.setState({situacaoPessoa: response.data.situacaoPessoa});
        if(response.data.dataNascimento != '' && response.data.dataNascimento != null) {
          var dataNasc = new Date(response.data.dataNascimento);
          dataNasc.setDate(dataNasc.getDate()+1)
          this.setState({dataNascimento: new Date(Date.parse(dataNasc))})
        }
        this.setState({profissao: response.data.profissao});
        this.setState({atividadeEconomica: response.data.atividadeEconomica});
        this.setState({estadoCivil: response.data.estadoCivil});
        this.setState({cpfCnpj: response.data.cpfCnpj});
        this.setState({rg: response.data.rg});
        this.setState({passaporte: response.data.passaporte});
        this.setState({tituloEleitor: response.data.tituloEleitor});
        this.setState({reservista: response.data.reservista});
        this.setState({pis: response.data.pis});
        this.setState({cnh: response.cnh});
        this.setState({ctps: response.data.ctps});
        this.setState({nomeMae: response.data.nomeMae});
        this.setState({nomePai: response.data.nomePai});
        this.setState({naturalidade: response.data.naturalidade});
        this.setState({macionalidade: response.data.nacionalidade});
        this.setState({perfil: response.data.perfil});
        this.setState({email: response.data.email});
        this.setState({telefone1: response.data.telefone1});
        this.setState({telefone2: response.data.telefone2});
        this.setState({endereco: response.data.endereco});
        this.setState({numero: response.data.numero});
        this.setState({tipoEndereco: response.data.tipoEndereco});
        this.setState({bairro: response.data.bairro});
        this.setState({cep: response.data.cep});
        this.setState({estado: response.data.cidade.estado});
        this.setState({cidade: response.data.cidade});
        this.setState({grupoCliente: response.data.grupoCliente});
        this.setState({captador: response.data.captador});
        this.setState({contaCorrente: response.data.contaCorrente});
        this.setState({agencia: response.data.agencia});
        this.setState({banco: response.data.banco});
        this.setState({pix: response.data.pix});
        this.setState({observacao: response.data.observacao});
        this.setState({atividades: response.data.atividades})
        this.setState({vinculoPrevidenciario: response.data.vinculuPrevidenciario});
        this.setState({calculos: response.data.calculosTipoContribuicao});
        if(response.data.status == '0') {
          this.setState({statusPessoa: {
            codigo: '0', nome: 'Ativo'
          }});
        } else {
          this.setState({statusPessoa: {
            codigo: '1', nome: 'Inativo'
          }});
        }
        //Novo módulo previdenciário
        this.setState({numeroBeneficio: response.data.numeroBeneficio});
        this.setState({tipoBeneficio: response.data.tipoBeneficio});
        if(response.data.dataEntradaRequerimento != '' && response.data.dataEntradaRequerimento != null) {
          var dataEntradaRequerimento = new Date(response.data.dataEntradaRequerimento);
          dataNasc.setDate(dataNasc.getDate()+1)
          this.setState({dataEntradaRequerimento: new Date(Date.parse(dataEntradaRequerimento))})
        }    
        
        if(response.data.dataInicioBeneficio != '' && response.data.dataInicioBeneficio != null) {
          var dataInicioBeneficio = new Date(response.data.dataInicioBeneficio);
          dataNasc.setDate(dataNasc.getDate()+1)
          this.setState({dataInicioBeneficio: new Date(Date.parse(dataInicioBeneficio))})
        }
        
        if(response.data.dataCessacaoBeneficio != '' && response.data.dataCessacaoBeneficio != null) {
          var dataCessacaoBeneficio = new Date(response.data.dataCessacaoBeneficio);
          dataNasc.setDate(dataNasc.getDate()+1)
          this.setState({dataCessacaoBeneficio: new Date(Date.parse(dataCessacaoBeneficio))})
        } 
        
        if(response.data.dataUltimaContribuicao != '' && response.data.dataUltimaContribuicao != null) {
          var dataUltimaContribuicao = new Date(response.data.dataUltimaContribuicao);
          dataNasc.setDate(dataNasc.getDate()+1)
          this.setState({dataUltimaContribuicao: new Date(Date.parse(dataUltimaContribuicao))})
        }   

        this.setState({senhaCliente: response.data.senhaSerasa});

        this.setState({tempoContribuicaoAnos: response.data.tempoContriuicaoAno});
        this.setState({tempoContribuicaoMeses: response.data.tempoContriuicaoMeses});
        this.setState({idadeDataEntradaRequerimento: response.data.idadeDer})
        this.setState({historico: response.data.historico});
        var dataCadastro = new Date(response.data.dataCadastro);
        dataCadastro.setDate(dataCadastro.getDate()+1)
        this.setState({dataCadastro: dataCadastro});
        var ultimaAlteracao = new Date(response.data.dataUltimaAlteracao);
        ultimaAlteracao.setDate(ultimaAlteracao.getDate()+1)
        this.setState({dataUltimaAlteracao: ultimaAlteracao});
        this.listarPerfisPessoa();
        this.listarEstadosCivil();
        this.listarTiposEndereco();
        this.listarGruposPessoas();
        this.listarCaptadores();
        this.listarEstados();
        this.listarArquivosPessoa(response.data.codigo);
        this.consultarProcessos(response.data.codigo);
        this.consultarAtendimentos(response.data.codigo);
      }).catch(error => {
        console.log('Error ', error);
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Pessoas', detail:`${this.state.detail}`, life: 4000});
      });
      console.log('Senha do cliente ', this.state.senhaCliente)
      this.setState({openSpinner: false});
  }

  consultarProcessos = async (pessoa) => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.pessoaService.consultarProcessos(pessoa, usuarioLogado.codigo)
      .then(response => {
        this.setState({processos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesProcessos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-search" className="p-button-rounded p-button-text" 
                tooltip="Editar"
                onClick={() => this.editarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  editarProcesso(processo) {
    //this.props.history.push(`/fichaProcesso/${processo.codigo}`);
    window.open(`/#/fichaProcesso/${processo.codigo}/SEARCH`, "_blank")
  }

  //Upload de Documentos
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('pessoa',upLoadFile.file, this.state.codigo); //Envia código da pessoa para criar diretório
    data.append('usuario', upLoadFile.file, usuarioLogado.codigo);
    await this.arquivoPessoaService.incluirArquivo(data)
      .then(response => {
        this.listarArquivosPessoa(this.state.codigo);
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosPessoa = async (codigo) => {
    await this.arquivoPessoaService.listarArquivos(codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  async consultarArquivo(codigo) {
    await this.arquivoPessoaService.consultarArquivo(codigo)
      .then(response => {
        this.setState({arquivo: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarArquivoDescricao(rowData) {
    await this.arquivoPessoaService.consultarArquivo(rowData.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({descricao: response.data.descricao});
        this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
            <button type="button" 
                    className="btn btn-primary bg-gradient-secondary" 
                    onClick={() => this.fecharModalCadastro(name)}>
                <i className="fas fa-times"></i> Cancelar
            </button>
            <button type="button" className="btn btn-primary bg-gradient-success"
                    onClick={() => this.adicionarDescricao()}>
                <i className="fas fa-check"></i> Alterar
            </button>
        </div>
    );
  }

  async adicionarDescricao(){
    await this.arquivoPessoaService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      descricao: this.state.descricao
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosPessoa(this.state.pessoa.codigo);
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState({descricaoHistorico: ''});
    this.setState(state);
  }

  excluirArquivo = async () => { 
    await this.arquivoPessoaService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosPessoa(this.state.pessoa.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoPessoaService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }


  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  alterarPessoa = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    //Data de nascmento
    var dataFormatadaDataNascimento = null;
    if(this.state.dataNascimento != '' && this.state.dataNascimento  != null) {
      var date = this.state.dataNascimento;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataFormatadaDataNascimento =  year+"-"+month+"-"+day;
    }

    var dataEntradaRequerimento = null;
    if(this.state.dataEntradaRequerimento != '' && this.state.dataEntradaRequerimento != null) {
      var date = this.state.dataEntradaRequerimento;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataEntradaRequerimento =  year+"-"+month+"-"+day;
    }

    var dataInicioBeneficio = null;
    if(this.state.dataInicioBeneficio != '' && this.state.dataInicioBeneficio != null) {
      var date = this.state.dataInicioBeneficio;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataInicioBeneficio =  year+"-"+month+"-"+day;
    }

    var dataCessacaoBeneficio = null;
    if(this.state.dataCessacaoBeneficio != '' && this.state.dataCessacaoBeneficio != null) {
      var date = this.state.dataCessacaoBeneficio;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataCessacaoBeneficio =  year+"-"+month+"-"+day;
    }

    var dataUltimaContribuicao = null;
    if(this.state.dataUltimaContribuicao != '' && this.state.dataUltimaContribuicao != null) {
      var date = this.state.dataUltimaContribuicao;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      dataUltimaContribuicao =  year+"-"+month+"-"+day;
    }

    this.setState({openSpinner: true});
    await this.pessoaService.alterarPessoa({
      codigo: this.state.pessoa.codigo,
      tipoPessoa: this.state.tipoPessoa.codigo,
      status: this.state.statusPessoa.codigo,
      nome: this.state.nome,
      perfil: this.state.perfil,
      dataNascimento: dataFormatadaDataNascimento,
      profissao: this.state.profissao,
      atividadeEconomica: this.state.atividadeEconomica,
      estadoCivil: this.state.estadoCivil,
      cpfCnpj: this.state.cpfCnpj,
      rg: this.state.rg,
      passaporte: this.state.passaporte,
      tituloEleitor: this.state.tituloEleitor,
      reservista: this.state.reservista,
      pis: this.state.pis,
      cnh: this.state.cnh,
      ctps: this.state.ctps,
      nomeMae: this.state.nomeMae,
      nomePai: this.state.nomePai,
      grupoCliente: this.state.grupoCliente,
      captador: this.state.captador,
      naturalidade: this.state.naturalidade,
      nacionalidade: this.state.nacionalidade,
      email: this.state.email,
      telefone1: this.state.telefone1,
      telefone2: this.state.telefone2,
      endereco: this.state.endereco,
      numero: this.state.numero,
      tipoEndereco: this.state.tipoEndereco,
      bairro: this.state.bairro,
      cep: this.state.cep,
      cidade: this.state.cidade,
      tipoConta: this.state.tipoConta.codigo,
      contaCorrente: this.state.contaCorrente,
      agencia: this.state.agencia,
      banco: this.state.banco,
      pix: this.state.pix,
      observacao: this.state.observacao,
      numeroBeneficio: this.state.numeroBeneficio,
      tipoBeneficio: this.state.tipoBeneficio,
      dataEntradaRequerimento: dataEntradaRequerimento,
      dataInicioBeneficio: dataInicioBeneficio,
      dataCessacaoBeneficio: dataCessacaoBeneficio,
      dataUltimaContribuicao: dataUltimaContribuicao,
      tempoContriuicaoAno: this.state.tempoContribuicaoAnos,
      tempoContriuicaoMeses: this.state.tempoContribuicaoMeses,
      idadeDer: this.state.idadeDataEntradaRequerimento,
      empresa: usuarioLogado.empresa,
      usuario: usuarioLogado.codigo

    }).then(response => {
      this.toast.show({severity:'success', summary: 'Edição de Pessoas', detail:'Pessoa alterada com sucesso!', life: 4000});
      this.consultarPessoa(this.state.pessoa.codigo);
    }).catch(error => {
      this.setState({openSpinner: false}); 
      this.toast.show({severity:'error', summary: 'Edição de Pessoas', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({openSpinner: false});
  }

  voltar = () => {
    const consultaFiltro = LocalStorageService.obterConsulta('_consulta_pessoa_filtro');
    const consultaFiltroJson = JSON.parse(consultaFiltro);

    if(consultaFiltroJson != null) {
      let params = `/pessoas?empresa=${consultaFiltroJson.empresa}&usuario=${consultaFiltroJson.usuario}`;
      
      if(consultaFiltroJson.nome != null) {
        params = `${params}&nome=${consultaFiltroJson.nome}`;
      }
  
      if(consultaFiltroJson.cpfCnpj != null) {
        params = `${params}&cpfCnpj=${consultaFiltroJson.cpfCnpj}`;
      }
  
      if(consultaFiltroJson.cidade != null) {
        params = `${params}&cidade=${consultaFiltroJson.cidade}`;
      }
  
      if(consultaFiltroJson.telefone != null) {
        params = `${params}&telefone=${consultaFiltroJson.telefone}`;
      }
  
      if(consultaFiltroJson.porLetra != null) {
        params = `${params}&letra=${consultaFiltroJson.letra}&porLetra=${consultaFiltroJson.porLetra}`;
      }
  
      if(consultaFiltroJson.grupo != null) {
        params = `${params}&grupo=${consultaFiltroJson.grupo}`;
      }

      this.props.history.push(params);

    } else {
      this.props.history.push('/pessoas')
    }
  }

  statusTemplate(data) {
    if(data.importante == 'S' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
          &nbsp;
          <Tag style={{backgroundColor: 'red'}} value="Urgente"></Tag>
          &nbsp;
          <Tag style={{backgroundColor: '#3B82F6'}} value="Importante"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'S' && data.urgente == 'N') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
          &nbsp;
          <Tag style={{backgroundColor: '#3B82F6'}} value="Importante"></Tag>
        </React.Fragment>
      );
    } else if(data.importante == 'N' && data.urgente == 'S') {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
          &nbsp;
          <Tag style={{backgroundColor: 'red'}} value="Urgente"></Tag>
        </React.Fragment>
      );
    } else {
      return(
        <React.Fragment>
          <Tag className="p-mr-2" style={{backgroundColor: `${data.corStatus}`}} value={data.status}></Tag>
        </React.Fragment>
      );
    }
  }

  linkConsultarAtividade(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.consultarAtividade(rowData)} style={{cursor: 'pointer', color: 'blue'}}>{rowData.atividade}</a>
      </React.Fragment>
    );
  }

  prazoFatal(rowData) {
    return(
      <React.Fragment>
        <span style={{color: 'red', fontWeight: 'bold'}}>{rowData.prazoFatal}</span>
      </React.Fragment>
    );
  }

  async consultarAtividade(atividade) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.consultarAtividadeCustom(atividade.codigo,usuarioLogado.empresa.codigo,usuarioLogado.codigo)
      .then(response => {
        console.log('Dados da atividade financeiro ', response.data);
        this.setState({atividade: response.data});
        this.setState({codigoAtividade: response.data.codigo});
        this.setState({codigoProcesso: response.data.codigoProcesso});
        this.setState({tituloAtividade: response.data.titulo});
        this.setState({pontuacao: response.data.pontos + " pontos"});
        this.setState({usuarioCriouAtividade: response.data.usuarioCriou});
        this.setState({dataRegistroAtividade: response.data.dataCriacao});
        this.setState({descricao: response.data.descricao});
        this.setState({grupoTrabalhoDescricao: response.data.grupo});
        this.setState({subGrupoTrabalhoDescricao: response.data.subGrupo});
        this.setState({codigoSubGrupo: response.data.codigoSubGrupo});
        this.setState({codigoGrupo: response.data.codigoGrupo});
        this.setState({tipoAtividade: response.data.tipo});
        if(response.data.tipo == 'A') {
          this.setState({horaAntiga: response.data.hora})
          this.setState({hora: response.data.hora});
        }

        if(response.data.pessoa != null) {
          this.setState({pessoa: response.data.pessoa});
          this.setState({campoPessoaPesquisada: 'block'});
          this.setState({pessoaPesquisada: response.data.pessoa.nome});
        } else {
          this.setState({campoPessoaPesquisada: 'none'});
          this.setState({pessoaPesquisada: ''});
        }

        this.setState({dataLimiteAntiga: response.data.dataLimite});
        var dataLimite = new Date(response.data.dataLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        if(response.data.prazoFatal != null) {
          var dataFatal = new Date(response.data.prazoFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }

        this.setState({statusCodigo: response.data.statusCodigo});
        this.setState({status: response.data.statusEntty})
        this.setState({statusAtividade: response.data.status});

        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }
        this.setState({grau: grau});
        //Responsáveis
        this.setState({responsaveisLista: response.data.responsaveisAtividade});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.setState({responsaveis: response.data.usuariosGrupo});
        //Interessados
        this.setState({interessadosLista: response.data.interessadosAtividade});
        if(response.data.interessadosAtividade != null) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }

        this.setState({interessados: response.data.usuariosGrupo});

        this.setState({descricaoStatus: response.data.statusEntty.status});

        if(response.data.lancamentoFinanceiro != null) {
          this.setState({isLancamento: true});
          this.setState({linkLancamento: 'hide'});
        }

      }).catch(error => {
        console.log('Erro ', error);
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
      //Abre modal
      await this.consultarHistorico(this.state.codigoAtividade)
      this.abrirModal('displayAtividade');
      this.setState({openSpinner: false});
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  alterarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.tituloAtividade == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null || this.state.responsaveisLista.size == 0) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.atividade.tipoAtividade == "L") {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = 'L';
      } else {
        if(this.state.hora != '' && this.state.hora != null) {
          var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
          tipoTarefa = 'A';
        } else {
          var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
          tipoTarefa = 'T';
        }
      }
    }

    var dataFormatadaDataFatal = "";
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != null && this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';
    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    var processo = null;
    if(this.state.codigoProcesso != null) {
      processo = {
        codigo: this.state.codigoProcesso
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.tituloAtividade,
        tipo: tipoTarefa,
        descricao: this.state.descricaoAtividade,
        usuario: usuarioLogado,
        processo: null,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.status,
        subGrupo: {
          codigo: this.state.codigoSubGrupo,
          grupoPai: this.state.codigoGrupo
        },
        importante: importante,
        urgente: urgente,
        privado: privado,
        pessoa: this.state.pessoa
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.horaAntiga != null && this.state.horaAntiga != "") {
      hora = this.state.horaAntiga;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.dataLimiteAntiga + " " + hora + ":00",
      this.state.statusCodigo, usuarioLogado.codigo,atividadeAlterar
      ).then(response => {
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
        this.fecharModal('displayAtividade');
      }).catch(error => {
        console.log('Error ', error);
        this.setState(error.response.data);
        this.fecharModal('displayAtividade');
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 8000});
      });
      await this.consultarAtividadesPorPessoa();
      this.setState({openSpinner: false});
  }

  templateHistoricoAtividade(data) {
    if(data.dataAlteracao != null) {
      return (
        <div className="col-12">
          <div className="balao" style={{borderRadius: '6px'}}>
            <Editor value={data.dsHistorico} 
                    headerTemplate={
                      <div>
                          <strong style={{textAlign: 'left', color: 'blue'}}
                                  className="grupoTrabalho">
                            {data.usuario.nome} - {data.dtHistorico}
                          </strong>
                          &nbsp;&nbsp;&nbsp;
                          <a onClick={() => this.consultarHistoricoAtividade(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-pencil" 
                            title="Alterar Histórico"/>
                          </a>
                          &nbsp;&nbsp;
                          <a onClick={() => this.confirmaExclusaoHistorico(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-times-circle" 
                            title="Excluir histórico. Apenas o usuário que o escreveu pode executar esta ação"/>
                          </a>
                          &nbsp;&nbsp;&nbsp;&nbsp;
                          <strong>Editado em &nbsp;{data.dataAlteracao}</strong>
                      </div>
                    }
                    readOnly
                    style={{ height: '120px' }} />
          </div>
          <br/>
        </div>
      );
    } else {
      return (
        <div className="col-12">
          <div className="balao" style={{borderRadius: '6px'}}>
            <Editor value={data.dsHistorico} 
                    headerTemplate={
                      <div>
                          <strong style={{textAlign: 'left', color: 'blue'}}
                                  className="grupoTrabalho">
                            {data.usuario.nome} - {data.dtHistorico}
                          </strong>
                          &nbsp;&nbsp;&nbsp;
                          <a onClick={() => this.consultarHistoricoAtividade(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-pencil" 
                            title="Alterar Histórico"/>
                          </a>
                          &nbsp;&nbsp;
                          <a onClick={() => this.confirmaExclusaoHistorico(data)} style={{cursor: 'pointer'}}>
                            <i className="pi pi-times-circle" 
                            title="Excluir histórico. Apenas o usuário que o escreveu pode executar esta ação"/>
                          </a>
                      </div>
                    }
                    readOnly
                    style={{ height: '120px' }} />
          </div>
          <br/>
        </div>
      );
    }
  }

  //Tudo relacionado a histórico

  consultarHistorico = async (codigo) => {
    await this.atividadeService.consultarHistorico(codigo)
      .then(response => {
        this.setState({historicoAtividades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarHistoricoAtividade(historico) {
    this.setState({openSpinner: true});
    await this.atividadeService.consultarHistoricoPorCodigo(historico.codigo)
      .then(response => {
        this.setState({dsHistorico: response.data.dsHistorico});
        this.setState({historicoAtividade: response.data});
        this.abrirModal('modalAlterarHistorico');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico da Atividade', detail:`${this.state.detail}`, life: 4000});
      })
  }


  novoHistorico = () => {
    this.setState({dsHistorico: ''});
    this.abrirModalHistorico('displayHistoricoIncluir');
  }

  async incluirHistorico () {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }
 
    this.setState({openSpinner: true});
    await this.atividadeService.incluirHistorico({
      atividade: {
        codigo: this.state.codigoAtividade
      },
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: 'M'
    }).then(response => {
      this.listarHistorico();
      this.fecharModal('displayHistoricoIncluir');
      this.toast.show({severity:'success', summary: 'Histórico de Atividade', detail:'Histórico incluído com sucesso', life: 4000});
    }).catch(error => {
      this.setState({openSpinner: false});
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Histórico de Atividade', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({openSpinner: false});
  }

  alterarHistoricoAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    const historico =  {
      codigo: this.state.historicoAtividade.codigo,
      usuario: usuarioLogado,
      tpHistorico: 'M',
      atividade: {
        codigo: this.state.codigoAtividade
      },
      dsHistorico: this.state.dsHistorico,
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarHistorico(historico)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Histórico de Atividade', detail:'Histórico alterado com sucesso!', life: 4000});
        this.listarHistorico();
        this.fecharModal('modalAlterarHistorico');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Histórico de Atividade', detail:`${error}`, life: 4000});
      })
  }

  listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigoAtividade)
      .then(response => {
        this.setState({historicoAtividades: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o histórico da atividade?',
        header: 'Exclusão de Histórico de Atividade',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.excluirHistorico,
        reject: this.reject
    });
  } 

  excluirHistorico = async () => {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.excluirHistorico(this.state.registroHistorico.codigo, 
      this.state.registroHistorico.usuario.codigo, usuarioLogado.codigo)
      .then(response => {
        this.listarHistorico();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico excluído com sucesso!', life: 4000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarHistoricoAtividade(historico) {
    this.setState({openSpinner: true});
    await this.atividadeService.consultarHistoricoPorCodigo(historico.codigo)
      .then(response => {
        this.setState({dsHistorico: response.data.dsHistorico});
        this.setState({historicoAtividade: response.data});
        this.abrirModal('modalAlterarHistorico');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Histórico da Atividade', detail:`${this.state.detail}`, life: 4000});
      })
  }

  novaAtividade = async () => {
    this.setState({openSpinner: true});
    this.setState({tituloAtividade: null});
    await this.listarTitulos();
    await this.consultarGruposTrabalho();
    this.limparCamposAtividade();
    this.abrirModal('modalNovaAtividade');
    this.setState({openSpinner: false});
  }

  listarTitulos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulosAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Títulos de Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
      })
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  consultarSubGrupos = async() => {
    await this.grupoTrabalhoService.listarSubGrupos(this.state.grupoTrabalho.codigo)
      .then(response => {
        this.setState({subGruposTrabalho: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:`Erro ao varregar sub-grupos - ${error}`, life: 4000});
      })
  }

  async onGrupoTrabalhoUsuariosAtivosChange(e) {
    if(e.value != null) {
      await this.setState({grupoTrabalho: e.value});
      await this.consultarSubGrupos();
      await this.listarResponsaveisAtivos();
      await this.listarInteressadosAtivos();
    } else {
      this.setState({selectGrupo: null});
      this.setState({selectSubGrupo: null});
      this.setState({subGrupos: null});
    }
  }

  listarResponsaveisAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.grupoTrabalho.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressadosAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.grupoTrabalho.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  limparCamposAtividade = () => {
    this.setState({tituloAtividde: null});
    this.setState({horaAtividade: ''});
    this.setState({descricaoAtividade: ''});
    this.setState({dtLimite: ''});
    this.setState({dtFatal: ''});
    this.setState({tipoAtividade: ''});
    this.setState({responsavel: null});
    this.setState({interessado: null});
    this.setState({responsaveis: []});
    this.setState({grupoTrabalho: null});
  }

  cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    
    if(this.state.tituloAtividade == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }
 
    if(this.state.grupoTrabalho == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.subGrupoTrabalho == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    //Responsaveis
    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    //Interessados
    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    } else {
      interessados = null;
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    var processo = null;
    if(this.state.processo != null) {
      processo = {
        codigo: this.state.processo.codigo
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';

    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    const cadastroAtividade = {
      atividade: {
        titulo: this.state.tituloAtividade.titulo,
        processo: null,
        subGrupo: this.state.subGrupoTrabalho,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        //configuracaoTarefa: this.state.configuracaoTarefa,
        status: {
          codigo: 1
        }, // Ativo
        importante: importante,
        urgente: urgente,
        privado: privado,
        pessoa: this.state.pessoa,
        tituloAtividade: this.state.tituloAtividade,
        lancamentoFinanceiro: null
      },
      responsaveis: this.state.responsavel,
      interessados: this.state.interessado,
      recorrencia: recorrencia,
      responsaveisSubTarefas: null,
      interessadosSubTarefas: null
    }
    this.setState({openSpinner: true});
    await this.atividadeService.cadastrarAtividade(cadastroAtividade).
      then(response => {
        this.fecharModal('modalNovaAtividade');
        //this.cadastrarExecucaoCheckList(response.data);
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
    }).catch(error => {
      this.setState({openSpinner: false})
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });
    await this.consultarAtividadesPorPessoa();
    this.setState({openSpinner: false});
  }

  onGrauChange(e) {
    let selectedGrau = [...this.state.grau];

    if (e.checked)
      selectedGrau.push(e.value);
    else
      selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

    this.setState({ grau: selectedGrau });
  }

  consultarAtividadesPorPessoa = async () => {
    await this.pessoaService.consultarAtividadesPorPessoa(this.state.pessoa.codigo)
      .then(response => {
        this.setState({atividades: response.data}); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades por Pessoa', detail:`${error}`, life: 4000});
      })
  }

  listarTiposBeneficios = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tipoBeneficioService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({tiposBeneficios: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Tipos de Bnefícios', detail:`${error}`, life: 4000});
      })
  }

  novoVinculoPrevidenciario = () => {
    this.setState({cpfCnpjEmpregador: ''});
    this.setState({empregador: ''});
    this.setState({periodoVinculoInicial: ''});
    this.setState({periodoVinculoFinal: ''});
    this.setState({tipoContribuicao: null});
    this.setState({snEspecialVinculo: ''});
    this.abrirModal('modalVinculoPrevidenciario');
  }

  cadastrarNovoVinculo = async () => {
    if(this.state.cpfCnpjEmpregador == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o CPF/CNPJ do empregador', life: 4000});
      return;
    }

    if(this.state.empregador == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o nome do empregador', life: 4000});
      return;
    }

    if(this.state.periodoVinculoInicial == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o período inicial do vínculo', life: 4000});
      return;
    }

    if(this.state.periodoVinculoFinal == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o período final do vínculo', life: 4000});
      return;
    }

    if(this.state.tipoContribuicao == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o tipo de contribuição', life: 4000});
      return;
    }

    if(this.state.snEspecialVinculo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe se é especial', life: 4000});
      return;
    }

    const pessoa = {
      codigo: this.state.pessoa.codigo
    }

    const vinculo = {
      pessoa: pessoa,
      cnpjCpfEmpregador: this.state.cpfCnpjEmpregador,
      empregador: this.state.empregador,
      periodoInicio: this.formataData(this.state.periodoVinculoInicial),
      periodoFim: this.formataData(this.state.periodoVinculoFinal),
      tipoContribuicao: this.state.tipoContribuicao.codigo,
      snEspecial: this.state.snEspecialVinculo.codigo
    };

    this.setState({openSpinner: true});
    await this.vinculoPrevidenciarioService.cadastrar(vinculo)
      .then(response => {
        this.consultarVincuosPrevidenciarios();
        this.toast.show({severity:'success', summary: 'Cadastro de Vínculo Previdenciário', detail:'Vínculo previdenciário cadastrado com sucesso', life: 5000});
        this.setState({openSpinner: false});
        this.fecharModal('modalVinculoPrevidenciario');
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:`${error}`, life: 5000});
      })
  }

  consultarVincuosPrevidenciarios = async () => {
    await this.vinculoPrevidenciarioService.consultarPorPessoa(this.state.pessoa.codigo)
      .then(response => {
        this.setState({vinculoPrevidenciario: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:`${error}`, life: 5000});
      })
  }

  formataData = (dataPtBr) => {
    return dataPtBr
      .split("/")     // separa ["dd", "MM", "yyyy"]
      .reverse()      // vira ["yyyy", "MM", "dd"]
      .join("-");     // junta em "yyyy-MM-dd"
  }

  acoesVinculosPrevidenciarios(rowData) {
    return(
        <div>
          <Button icon="pi pi-pencil" 
                  style={{ color: 'var(--primary-color)' }} 
                  className="p-button-rounded p-button-text" 
                  tooltip="Editar"
                  onClick={() => this.consultarVinculoPrevidenciario(rowData)} 
                  tooltipOptions={{position: 'top'}} />
          &nbsp;
          <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoVinculoPrevidenciario(rowData)} 
                tooltip="Excluir Vínculo" 
                tooltipOptions={{position: 'top'}}/>
        </div>
    );
  }

  acoesCalculosTipoContribuicao(rowData) {
    return(
        <div>
          <Button icon="pi pi-search" 
                  style={{ color: 'var(--primary-color)' }} 
                  className="p-button-rounded p-button-text" 
                  tooltip="Consultar"
                  onClick={() => this.consultarCalculo(rowData)} 
                  tooltipOptions={{position: 'top'}} />
          &nbsp;
          <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                onClick={() => this.confirmaExclusaoCalculoTipoAposentadoria(rowData)} 
                tooltip="Excluir Cálculo" 
                tooltipOptions={{position: 'top'}}/>
        </div>
    );
  }

  confirmaExclusaoVinculoPrevidenciario(vinculo) {
    this.setState({codigoVinculo: vinculo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este vínculo previdenciário ?',
        header: 'Exclusão de Vínculo Previdenciário',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.excluirVinculoPrevidenciario,
        reject: this.reject
    });
  }

  excluirVinculoPrevidenciario = async () => {
    this.setState({openSpinner: true});
    await this.vinculoPrevidenciarioService.excluir(this.state.codigoVinculo)
      .then(response => {
        this.consultarVincuosPrevidenciarios();
        this.toast.show({severity:'success', summary: 'Exclusão de Vínculo Previdenciário', detail:'Vínculo Previdenciário excluído com sucesso', life: 5000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:`${error}`, life: 5000});
        this.setState({openSpinner: false});
      })
  }

  async consultarVinculoPrevidenciario(vinculo) {
    this.setState({openSpinner: true});
    await this.vinculoPrevidenciarioService.consultar(vinculo.codigo)
      .then(response => {
        this.setState({vinculoPrevidenciarioRegistro: response.data});
        this.setState({codigoVinculo: response.data.codigo});
        this.setState({cpfCnpjEmpregador: response.data.cnpjCpfEmpregador});
        this.setState({empregador: response.data.empregador});
        this.setState({periodoVinculoInicial: response.data.periodoInicioFormat});
        this.setState({periodoVinculoFinal: response.data.periodoFimFormat});
        this.setState({tipoContribuicao: this.retornaTipoContribuicao(response.data.tipoContribuicao)});
        if(response.data.snEspecial == 'S') {
          this.setState({snEspecialVinculo: {
            codigo: 'S',
            nome: 'SIM'
          }});
        } else {
          this.setState({snEspecialVinculo: {
            codigo: 'N',
            nome: 'NÃO'
          }});
        }
        this.abrirModal('modalVinculoPrevidenciarioAlterar');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Consulta de Vínculo Previdenciário', detail:`${error}`, life: 5000});
        this.setState({openSpinner: false});
      })
  }

  retornaTipoContribuicao = (codigo) => {
    var tipoContribuicao = null;
    for(let i = 0; i < this.tipoContribuicao.length; i++) {
      if(this.tipoContribuicao[i].codigo == codigo) {
        tipoContribuicao = this.tipoContribuicao[i];
        return tipoContribuicao;
      }
    }
  }

  alterarVinculoPrevidenciario = async () => {
    if(this.state.cpfCnpjEmpregador == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o CPF/CNPJ do empregador', life: 4000});
      return;
    }

    if(this.state.empregador == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o nome do empregador', life: 4000});
      return;
    }

    if(this.state.periodoVinculoInicial == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o período inicial do vínculo', life: 4000});
      return;
    }

    if(this.state.periodoVinculoFinal == '') {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o período final do vínculo', life: 4000});
      return;
    }

    if(this.state.tipoContribuicao == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe o tipo de contribuição', life: 4000});
      return;
    }

    if(this.state.snEspecialVinculo == null) {
      this.toast.show({severity:'error', summary: 'Cadastro de Vínculo Previdenciário', detail:'Informe se é especial', life: 4000});
      return;
    }

    const pessoa = {
      codigo: this.state.pessoa.codigo
    }

    const vinculo = {
      codigo: this.state.codigoVinculo,
      pessoa: pessoa,
      cnpjCpfEmpregador: this.state.cpfCnpjEmpregador,
      empregador: this.state.empregador,
      periodoInicio: this.formataData(this.state.periodoVinculoInicial),
      periodoFim: this.formataData(this.state.periodoVinculoFinal),
      tipoContribuicao: this.state.tipoContribuicao.codigo,
      snEspecial: this.state.snEspecialVinculo.codigo
    };

    this.setState({openSpinner: true});
    await this.vinculoPrevidenciarioService.alterar(vinculo)
      .then(response => {
        this.consultarVincuosPrevidenciarios();
        this.toast.show({severity:'success', summary: 'Alteração de Vínculo Previdenciário', detail:'Vínculo previdenciário cadastrado com sucesso', life: 5000});
        this.setState({openSpinner: false});
        this.fecharModal('modalVinculoPrevidenciarioAlterar');
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Alteração de Vínculo Previdenciário', detail:`${error}`, life: 5000});
      })
  }

  novoCalculoTipoContribuicao = () => {
    this.setState({dataBaseCalculo: ''});
    this.setState({anosComum: ''});
    this.setState({mesesComum: ''});
    this.setState({diasComum: ''});
    this.setState({anosEspecial: ''});
    this.setState({mesesEspecial: ''});
    this.setState({diasEspecial: ''});
    this.setState({anosTotal: ''});
    this.setState({mesesTotal: ''});
    this.setState({diasTotal: ''});
    this.setState({fatorPrevidenciario: ''});
    this.setState({simulacaoResultado: ''});
    this.setState({tipoAposentadoria: null});
    this.setState({calculo: null});
    this.abrirModal('modalCalculo');
  }

  calcularTempoTipoContribuicao = async () => {
    if(this.state.dataBaseCalculo == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe a data da base de cálculo', life: 5000});
      return;
    }

    if(this.state.anosComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Comum', life: 5000});
      return;
    }

    if(this.state.mesesComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Comum', life: 5000});
      return;
    }

    if(this.state.diasComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Comum', life: 5000});
      return;
    }

    if(this.state.anosEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Especial', life: 5000});
      return;
    }

    if(this.state.mesesEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Especial', life: 5000});
      return;
    }

    if(this.state.diasEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Especial', life: 5000});
      return;
    }

    const calculo = {
      anosComum: this.state.anosComum,
      mesesComum: this.state.mesesComum,
      diasComum: this.state.diasComum,
      anosEspecial: this.state.anosEspecial,
      mesesEspecial: this.state.mesesEspecial,
      diasEspecial: this.state.diasEspecial
    }

    this.setState({openSpinner: true});
    await this.calculoService.calcularTempo(calculo)
      .then(response => {
        this.setState({anosTotal: response.data.anosTotal});
        this.setState({mesesTotal: response.data.mesesTotal});
        this.setState({diasTotal: response.data.diasTotal});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:`${error}`, life: 5000});
      })
  }

  cadastrarTempoTipoContribuicao = async () => {
    if(this.state.dataBaseCalculo == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe a data da base de cálculo', life: 5000});
      return;
    }

    if(this.state.anosComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Comum', life: 5000});
      return;
    }

    if(this.state.mesesComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Comum', life: 5000});
      return;
    }

    if(this.state.diasComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Comum', life: 5000});
      return;
    }

    if(this.state.anosEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Especial', life: 5000});
      return;
    }

    if(this.state.mesesEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Especial', life: 5000});
      return;
    }

    if(this.state.diasEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Especial', life: 5000});
      return;
    }

    if(this.state.anosTotal == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Total', life: 5000});
      return;
    }

    if(this.state.mesesTotal == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Total', life: 5000});
      return;
    }

    if(this.state.diasTotal == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Total', life: 5000});
      return;
    }

    if(this.state.fatorPrevidenciario == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o fator previdenciário', life: 5000});
      return;
    }

    if(this.state.simulacaoResultado == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe a simulação de resultado', life: 5000});
      return;
    }

    if(this.state.tipoAposentadoria == null) {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o tipo de aposentadoria', life: 5000});
      return;
    }

    const tipoContribuicao = {
      pessoa: {
        codigo: this.state.pessoa.codigo
      },
      dataBase: this.formataData(this.state.dataBaseCalculo),
      anosComum: this.state.anosComum,
      mesesComum: this.state.mesesComum,
      diasComum: this.state.diasComum,
      anosEspecial: this.state.anosEspecial,
      mesesEspecial: this.state.mesesEspecial,
      diasEspecial: this.state.diasEspecial,
      anosTotal: this.state.anosTotal,
      mesesTotal: this.state.mesesTotal,
      diasTotal: this.state.diasTotal,
      fatorPrevidenciario: this.state.fatorPrevidenciario,
      simulacaoResultado: this.state.simulacaoResultado,
      tipoAposentadoriaSimulada: this.state.tipoAposentadoria.codigo
    }

    this.setState({openSpinner: true});
    await this.calculoService.cadastrar(tipoContribuicao)
      .then(response => {
        this.consultarCalculos();
        this.toast.show({severity:'success', summary: 'Cálculo Tipo de Contribuição', detail:'Regisro inseido com sucesso', life: 5000});
        this.fecharModal('modalCalculo');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:`${error}`, life: 5000});
        this.setState({openSpinner: false});
      })
  }

  consultarCalculos = async () => {
    await this.calculoService.consultarPorPessoa(this.state.pessoa.codigo)
      .then(response => {
        this.setState({calculos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:`${error}`, life: 5000});
      })
  }

  async consultarCalculo(rowData){
    this.setState({openSpinner: true});
    await this.calculoService.consultar(rowData.codigo)
      .then(response => {
        this.setState({calculo: response.data});
        this.setState({codigoCalculo: response.data.codigo});
        this.setState({dataBaseCalculo: response.data.dataBaseFormat});
        this.setState({anosComum: response.data.anosComum});
        this.setState({mesesComum: response.data.mesesComum});
        this.setState({diasComum: response.data.diasComum});
        this.setState({anosEspecial: response.data.anosEspecial});
        this.setState({mesesEspecial: response.data.mesesEspecial});
        this.setState({diasEspecial: response.data.diasEspecial});
        this.setState({anosTotal: response.data.anosTotal});
        this.setState({mesesTotal: response.data.mesesTotal});
        this.setState({diasTotal: response.data.diasTotal});
        this.setState({fatorPrevidenciario: response.data.fatorPrevidenciario});
        this.setState({simulacaoResultado: response.data.simulacaoResultado});
        this.setState({tipoAposentadoria: this.retornaTipoAposentadoria(response.data.tipoAposentadoriaSimulada)});
        this.abrirModal('modalCalculoAlterar');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:`${error}`, life: 5000});
      })
  }

  retornaTipoAposentadoria = (codigo) => {
    var tipoAposentadoria = null;
    for(let i = 0; i < this.tipoAposentadoria.length; i++) {
      if(this.tipoAposentadoria[i].codigo == codigo) {
        tipoAposentadoria = this.tipoAposentadoria[i];
        return tipoAposentadoria;
      }
    }
  }

  confirmaExclusaoCalculoTipoAposentadoria(calculo) {
    this.setState({codigoCalculo: calculo.codigo});
    confirmDialog({
        message: 'Deseja realmente escluir este registro de cálculo ?',
        header: 'Exclusão de Cálculo de Tipo de Aposentadoria',                                                                                                                                                                                       
        icon: 'pi pi-question-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.excluirCalculo,    
        reject: this.reject                                                                                             
    });
  }                                                 

  excluirCalculo = async () => {
    this.setState({openSpinner: true});
    await this.calculoService.excluir(this.state.codigoCalculo)
      .then(response => {
        this.consultarCalculos();
        this.toast.show({severity:'success', summary: 'Exclusão de Cálculo de Tipo de Aposentadoria', detail:'Cálculo excluído com sucesso', life: 5000});
        this.setState({openSpinner: false});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Exclusão de Cálculo de Tipo de Aposentadoria', detail:`${error}`, life: 5000});
        this.setState({openSpinner: false});
      })
  }

  alterarCalculoTipoAposentadoria = async () => {
    if(this.state.dataBaseCalculo == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe a data da base de cálculo', life: 5000});
      return;
    }

    if(this.state.anosComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Comum', life: 5000});
      return;
    }

    if(this.state.mesesComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Comum', life: 5000});
      return;
    }

    if(this.state.diasComum == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Comum', life: 5000});
      return;
    }

    if(this.state.anosEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Especial', life: 5000});
      return;
    }

    if(this.state.mesesEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Especial', life: 5000});
      return;
    }

    if(this.state.diasEspecial == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Especial', life: 5000});
      return;
    }

    if(this.state.anosTotal == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Anos Total', life: 5000});
      return;
    }

    if(this.state.mesesTotal == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Meses Total', life: 5000});
      return;
    }

    if(this.state.diasTotal == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o Dias Total', life: 5000});
      return;
    }

    if(this.state.fatorPrevidenciario == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o fator previdenciário', life: 5000});
      return;
    }

    if(this.state.simulacaoResultado == '') {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe a simulação de resultado', life: 5000});
      return;
    }

    if(this.state.tipoAposentadoria == null) {
      this.toast.show({severity:'error', summary: 'Cálculo Tipo de Contribuição', detail:'Informe o tipo de aposentadoria', life: 5000});
      return;
    }

    const calculo = {
      codigo: this.state.codigoCalculo,
      pessoa: {
        codigo: this.state.pessoa.codigo
      },
      dataBase: this.formataData(this.state.dataBaseCalculo),
      anosComum: this.state.anosComum,
      mesesComum: this.state.mesesComum,
      diasComum: this.state.diasComum,
      anosEspecial: this.state.anosEspecial,
      mesesEspecial: this.state.mesesEspecial,
      diasEspecial: this.state.diasEspecial,
      anosTotal: this.state.anosTotal,
      mesesTotal: this.state.mesesTotal,
      diasTotal: this.state.diasTotal,
      fatorPrevidenciario: this.state.fatorPrevidenciario,
      simulacaoResultado: this.state.simulacaoResultado,
      tipoAposentadoriaSimulada: this.state.tipoAposentadoria.codigo
    }

    this.setState({openSpinner: true});
    await this.calculoService.alterar(calculo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Alteração de Cálculo', detail:'Cálculo alterado com sucesso', life: 5000});
        this.consultarCalculos();
        this.fecharModal('modalCalculoAlterar');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Alteração de Cálculo', detail:`${error}`, life: 5000});
        this.setState({openSpinner: false});
      })
  }

  render() {
    const { upLoadFiles } = this.state;

    var criaTitulo = 'none';
    var criaGrupo = 'none';
    
    const usuarioLogado = this.context.usuarioAutenticado;
    const usuarioPerfil = usuarioLogado.perfil.codigo;

    if(usuarioPerfil == 1 || usuarioPerfil == 2) {
      criaTitulo = 'block';
    }

    if(usuarioPerfil == 1 || usuarioPerfil == 2) {
      criaGrupo = 'block';
   }
    
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="fas fa-user-tie"></i>
                    <span> Consulta de Pessoas</span>
                  </h3>  
                </div>
                <div className="card-body">
                  <TabView className="tabview-custom">
                    <TabPanel header="Informações Pessoais">
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Tipo de Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.tipoPessoa} 
                                      options={this.tipoPessoa} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeTipoPessoa}
                                      id="tipoPessoa"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Status<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.statusPessoa} 
                                      options={this.status} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={e => this.setState({statusPessoa: e.target.value})}
                                      id="statusPessoa"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <label>{this.state.labelNome}<span className="obrigatorioAsterisco"> *</span></label>
                            <InputText id="nome" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.nome}
                                      onChange={e => this.setState({nome: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Perfil Pessoa<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.perfil} 
                                      options={this.state.perfis} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangePerfil}
                                      id="perfilPessoa"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Telefone 1</label>
                            <InputMask id="telefone1" 
                                      mask="(99)-99999-9999"
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.telefone1}
                                      onChange={e => this.setState({telefone1: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Telefone 2</label>
                            <InputMask id="telefone1" 
                                      mask="(99)-99999-9999"
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.telefone2}
                                      onChange={e => this.setState({telefone2: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Email</label>
                            <InputText id="email" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.email}
                                      onChange={e => this.setState({email: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Tp. End.</label>
                            <Dropdown value={this.state.tipoEndereco} 
                                      options={this.state.tiposEndereco} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeTipoEndereco}
                                      id="tipoEndereco"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-8">
                          <div className="form-group">
                            <label>Endereço</label>
                            <InputText id="endereco" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.endereco}
                                      onChange={e => this.setState({endereco: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-1">
                          <div className="form-group">
                            <label>Número</label>
                            <InputText id="numero" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.numero}
                                        onChange={e => this.setState({numero: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Cep</label>
                            <InputText id="cep" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}}
                                        value={this.state.cep}
                                        onChange={e => this.setState({cep: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-7">
                          <div className="form-group">
                            <label>Bairro</label>
                            <InputText id="bairro" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.bairro}
                                       onChange={e => this.setState({bairro: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <label>Estado<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.estado} 
                                      options={this.state.estados} style={{width: '100%', height: '32px'}}
                                      optionLabel="estado" 
                                      onChange={this.onChangeEstado}
                                      id="estado"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-7">
                          <div className="form-group">
                            <label>Cidade<span className="obrigatorioAsterisco"> *</span></label>
                            <Dropdown value={this.state.cidade} 
                                      options={this.state.cidades} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeCidade}
                                      id="cidade"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel header="Informações Complementares">
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Data de Cadastro</label>
                            <Calendar id="dataCadastro" 
                                      value={this.state.dataCadastro}
                                      disabled
                                      onChange={(e) => this.setState({ dataCadastro: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Última Alteração</label>
                            <Calendar id="dataUltimaAlteracao" 
                                      value={this.state.dataUltimaAlteracao}
                                      disabled
                                      onChange={(e) => this.setState({ dataUltimaAlteracao: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Dt. Nasc.</label>
                            <Calendar id="mask" 
                                      value={this.state.dataNascimento} 
                                      onChange={(e) => this.setState({ dataNascimento: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Profissão</label>
                            <InputText id="profissao" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.profissao}
                                        onChange={e => this.setState({profissao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Atividade Econômica</label>
                            <InputText id="atividadeEconomica" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.atividadeEconomica}
                                      onChange={e => this.setState({atividadeEconomica: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Estado Civil</label>
                            <Dropdown value={this.state.estadoCivil} 
                                      options={this.state.estadosCivil} style={{width: '100%', height: '32px'}}
                                      optionLabel="nome" 
                                      onChange={this.onChangeCidade}
                                      id="cidade"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Naturalidade</label>
                            <InputText id="naturalidades" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.naturalidade}
                                      onChange={e => this.setState({naturalidade: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Nacionalidade</label>
                            <InputText id="naturalidades" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}}
                                      value={this.state.nacionalidade}
                                      onChange={e => this.setState({nacionalidade: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Nome da Mãe</label>
                            <InputText id="nomeMae" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nomeMae}
                                      onChange={e => this.setState({nomeMae: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Nome do Pai</label>
                            <InputText id="nomePai" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.nomePai}
                                      onChange={e => this.setState({nomePai: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <div className="row">
                     <div className="col-sm-5">
                      <div className="form-group">
                        <label>Grupo de Pessoas</label>
                        <Dropdown value={this.state.grupoCliente} 
                                  options={this.state.grupoPessoas} style={{width: '100%', height: '32px'}}
                                  onChange={this.onChangeGrupoPessoas} 
                                  optionLabel="nome"
                                  id="grupoCliente"
                                  filter showClear filterBy="nome"
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                     </div>
                     <div className="col-sm-5">
                      <div className="form-group">
                        <label>Parceiro</label>
                        <Dropdown value={this.state.captador} 
                                  options={this.state.captadores} 
                                  onChange={this.onChangeCaptador} 
                                  optionLabel="nome" 
                                  filter showClear filterBy="nome"
                                  style={{width: '100%', height: '32px'}}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                     </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-2">
                        <div className="form-group">
                          <label>Conta Bancária</label>
                          <Dropdown value={this.state.tipoConta} 
                                    options={this.conta} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    onChange={this.onChangeTipoConta}
                                    id="cidade"
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Número da Caonta</label>
                          <InputText id="conta" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.contaCorrente}
                                    onChange={e => this.setState({contaCorrente: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label>Agência</label>
                          <InputText id="agencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}}
                                    value={this.state.agencia}
                                    onChange={e => this.setState({agencia: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Banco</label>
                          <InputText id="agencia" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.banco}
                                    onChange={e => this.setState({banco: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                      <div className="col-sm-7">
                        <div className="form-group">
                          <label>Chave Pix</label>
                          <InputText id="pix" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.pix}
                                      onChange={e => this.setState({pix: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                        </div>
                      </div>
                    </div>
                    </TabPanel>
                    <TabPanel header="Documentação">
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CPF</label>
                            <InputMask id="cpf" 
                                        type="text" 
                                        mask="999.999.999-99"
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.cpfCnpj}
                                        onChange={e => this.setState({cpfCnpj: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>RG</label>
                            <InputText id="RG" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.rg}
                                        onChange={e => this.setState({rg: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoaJuridica}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CNPJ</label>
                            <InputMask id="cnpj" 
                                        type="text" 
                                        mask="99.999.999/9999-99"
                                        style={{width: '100%', height: '32px'}}
                                        value={this.state.cpfCnpj}
                                        onChange={e => this.setState({cpfCnpj: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CNH</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.cnh}
                                       onChange={e => this.setState({cnh: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>CTPS</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.ctps}
                                       onChange={e => this.setState({ctps: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>PIS</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.pis}
                                       onChange={e => this.setState({pis: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Passaporte</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.passaporte}
                                       onChange={e => this.setState({passaporte: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    <span style={this.state.defineTipoPessoa}>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Título de Eleitor</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}}
                                       value={this.state.tituloEleitor}
                                       onChange={e => this.setState({tituloEleitor: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Certidão de Reservista</label>
                            <InputText id="cnh" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.reservista}
                                       onChange={e => this.setState({reservista: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                    </span>
                    </TabPanel>
                    <TabPanel header="Previdenciário">
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Número do Benefício(NB)</label>
                            <InputText id="idNumeroBeneficio" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.numeroBeneficio}
                                       onChange={e => this.setState({numeroBeneficio: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Tipo de Benefício Solicitado</label>
                            <Dropdown value={this.state.tipoBeneficio} 
                                      options={this.state.tiposBeneficios} 
                                      onChange={e => this.setState({tipoBeneficio: e.target.value})}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      style={{width: '100%', height: '32px'}}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Senha Cliente</label>
                            <InputText id="senhaCliente" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.senhaCliente}
                                       onChange={e => this.setState({senhaCliente: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Data de Entrada do Requerimento (DER)</label>
                            <Calendar id="idDer" 
                                      value={this.state.dataEntradaRequerimento} 
                                      onChange={(e) => this.setState({ dataEntradaRequerimento: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Data de Início do Benefício (DIB)</label>
                            <Calendar id="idDib" 
                                      value={this.state.dataInicioBeneficio} 
                                      onChange={(e) => this.setState({ dataInicioBeneficio: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Data de Cessação do Benefício (DCB)</label>
                            <Calendar id="idDcb" 
                                      value={this.state.dataCessacaoBeneficio} 
                                      onChange={(e) => this.setState({ dataCessacaoBeneficio: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                        <div className="col-sm-5">
                          <div className="form-group">
                            <label>Data da Última Contribuição</label>
                            <Calendar id="idDataUltimaContribuicao" 
                                      value={this.state.dataUltimaContribuicao} 
                                      onChange={(e) => this.setState({ dataUltimaContribuicao: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Tempo Total de Contribuição (anos)</label>
                            <InputText id="idtempoContribuicaoAnos" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.tempoContribuicaoAnos}
                                       onChange={e => this.setState({tempoContribuicaoAnos: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-4">
                          <div className="form-group">
                            <label>Tempo Total de Contribuição (meses)</label>
                            <InputText id="idtempoContribuicaoMeses" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.tempoContribuicaoMeses}
                                       onChange={e => this.setState({tempoContribuicaoMeses: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-2">
                          <div className="form-group">
                            <label>Idade na DER</label>
                            <InputText id="iDidadeDataEntradaRequerimento" 
                                       type="text" 
                                       style={{width: '100%', height: '32px'}} 
                                       value={this.state.idadeDataEntradaRequerimento}
                                       onChange={e => this.setState({idadeDataEntradaRequerimento: e.target.value})}
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className="row">
                        <div className="col-sm-10">
                          <div className="form-group">
                            <Accordion multiple>
                              <AccordionTab header="Vínculos Previdenciários">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="form-group">
                                      <button type="button" className="btn btn-primary bg-gradient-primary" 
                                                data-toggle="modal" 
                                                onClick={this.novoVinculoPrevidenciario}
                                                data-target="#modal-default">
                                        <i className="fas fa-plus"></i> Cadastrar novo Vínculo</button>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="form-group">
                                      <DataTable value={this.state.vinculoPrevidenciario}
                                                 emptyMessage="Nenhum vínculo cadastrado"
                                                 size="small">
                                        <Column field="cnpjCpfEmpregador" header="CPF/CNPJ Empregador"></Column>
                                        <Column field="empregador" header="Empregador"></Column>
                                        <Column field="periodoInicioFormat" header="Período Inicial"></Column>
                                        <Column field="periodoFimFormat" header="Período Final"></Column>
                                        <Column field="tipoContribuicao" header="Tipo de Contribuição"></Column>
                                        <Column field="snEspecial" header="Especial (S/N)"></Column>
                                        <Column body={this.acoesVinculosPrevidenciarios} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                                      </DataTable>
                                    </div>
                                  </div>
                                </div>
                              </AccordionTab>
                              <AccordionTab header="Cálculos e Revisões">
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="form-group">
                                      <button type="button" className="btn btn-primary bg-gradient-primary" 
                                                data-toggle="modal" 
                                                onClick={this.novoCalculoTipoContribuicao}
                                                data-target="#modal-default">
                                        <i className="fas fa-plus"></i> Cadastrar novo Cálculo</button>
                                    </div>
                                  </div>
                                </div>
                                <div className="row">
                                  <div className="col-sm-12">
                                    <div className="form-group">
                                      <DataTable value={this.state.calculos}
                                                 emptyMessage="Nenhum cálculo cadastrado"
                                                 size="small">
                                        <Column field="dataBaseFormat" header="Data Base"></Column>
                                        <Column field="fatorPrevidenciarioFormat" header="Fator Previdenciário"></Column>
                                        <Column field="simulacaoResultadoFormat" header="Simulação. Resultado"></Column>
                                        <Column field="tipoAposentadoriaSimulada" header="Tipo Aposentadoria"></Column>
                                        <Column body={this.acoesCalculosTipoContribuicao} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                                      </DataTable>
                                    </div>
                                  </div>
                                </div>
                              </AccordionTab>
                            </Accordion>     
                          </div>
                        </div>
                      </div>

                      {/**Vínculo Previdenciário Cadastrar */}
                      <Dialog header="Cadastrar Vínculo Previdenciário"
                                visible={this.state.modalVinculoPrevidenciario} 
                                style={{ width: '40vw' }} 
                                footer={
                                  <div>
                                    <Button label="Cadastrar" 
                                            className="p-button-success p-button-text"
                                            onClick={this.cadastrarNovoVinculo}/>
                                    &nbsp;
                                    <Button label="Cancelar" 
                                            className="p-button-secondary p-button-text"
                                            onClick={() => this.fecharModal('modalVinculoPrevidenciario')}/>
                                  </div>
                                }
                                onHide={() => this.fecharModalCadastro('modalVinculoPrevidenciario')}>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>CPF/CNPJ do Empregador</label>
                             <InputText id="cpfCnpjEmpregador" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.cpfCnpjEmpregador}
                                        onChange={e => this.setState({cpfCnpjEmpregador: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-8">
                            <div className="form-group">
                             <label>Nome do Empregador</label>
                             <InputText id="nomeEmpregador" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.empregador}
                                        onChange={e => this.setState({empregador: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                             <label>Período Inicial</label>
                             <InputMask id="periodoInicial" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text"
                                        mask="99/99/9999"
                                        value={this.state.periodoVinculoInicial}
                                        onChange={e => this.setState({periodoVinculoInicial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                             <label>Período Final</label>
                             <InputMask id="periodoFinal" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text"
                                        mask="99/99/9999"
                                        value={this.state.periodoVinculoFinal}
                                        onChange={e => this.setState({periodoVinculoFinal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                             <label>Tipo de Contribuição</label>
                             <Dropdown value={this.state.tipoContribuicao} style={{width: '100%', height: '32px'}} 
                                       options={this.tipoContribuicao} style={{width: '100%', height: '32px'}}
                                       optionLabel="nome" 
                                       emptyMessage=" "
                                       filter showClear filterBy="nome"
                                       onChange={e => this.setState({tipoContribuicao: e.target.value})}
                                       id="idTipoTipoContribuicao"
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Especial ?</label>
                             <Dropdown value={this.state.snEspecialVinculo} style={{width: '100%', height: '32px'}} 
                                       options={this.especialContribuicao} style={{width: '100%', height: '32px'}}
                                       optionLabel="nome" 
                                       emptyMessage=" "
                                       filter showClear filterBy="nome"
                                       onChange={e => this.setState({snEspecialVinculo: e.target.value})}
                                       id="idSnEspecial"
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                      </Dialog>

                      {/**Vínculo Previdenciário Alterar */}
                      <Dialog header="Alterar Vínculo Previdenciário"
                                visible={this.state.modalVinculoPrevidenciarioAlterar} 
                                style={{ width: '40vw' }} 
                                footer={
                                  <div>
                                    <Button label="Alterar" 
                                            className="p-button-success p-button-text"
                                            onClick={this.alterarVinculoPrevidenciario}/>
                                    &nbsp;
                                    <Button label="Cancelar" 
                                            className="p-button-secondary p-button-text"
                                            onClick={() => this.fecharModal('modalVinculoPrevidenciarioAlterar')}/>
                                  </div>
                                }
                                onHide={() => this.fecharModal('modalVinculoPrevidenciarioAlterar')}>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>CPF/CNPJ do Empregador</label>
                             <InputText id="cpfCnpjEmpregador" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.cpfCnpjEmpregador}
                                        onChange={e => this.setState({cpfCnpjEmpregador: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-8">
                            <div className="form-group">
                             <label>Nome do Empregador</label>
                             <InputText id="nomeEmpregador" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.empregador}
                                        onChange={e => this.setState({empregador: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                             <label>Período Inicial</label>
                             <InputMask id="periodoInicial" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text"
                                        mask="99/99/9999"
                                        value={this.state.periodoVinculoInicial}
                                        onChange={e => this.setState({periodoVinculoInicial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                             <label>Período Final</label>
                             <InputMask id="periodoFinal" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text"
                                        mask="99/99/9999"
                                        value={this.state.periodoVinculoFinal}
                                        onChange={e => this.setState({periodoVinculoFinal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-8">
                            <div className="form-group">
                             <label>Tipo de Contribuição</label>
                             <Dropdown value={this.state.tipoContribuicao} style={{width: '100%', height: '32px'}} 
                                       options={this.tipoContribuicao} style={{width: '100%', height: '32px'}}
                                       optionLabel="nome" 
                                       emptyMessage=" "
                                       filter showClear filterBy="nome"
                                       onChange={e => this.setState({tipoContribuicao: e.target.value})}
                                       id="idTipoTipoContribuicao"
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Especial ?</label>
                             <Dropdown value={this.state.snEspecialVinculo} style={{width: '100%', height: '32px'}} 
                                       options={this.especialContribuicao} style={{width: '100%', height: '32px'}}
                                       optionLabel="nome" 
                                       emptyMessage=" "
                                       filter showClear filterBy="nome"
                                       onChange={e => this.setState({snEspecialVinculo: e.target.value})}
                                       id="idSnEspecial"
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                      </Dialog>

                      {/**Cálculo por tipo de contribuição */}
                      <Dialog header="Cadastrar cálculo tempo de contribuição"
                                visible={this.state.modalCalculo} 
                                style={{ width: '45vw' }} 
                                footer={
                                  <div>
                                    <Button label="Calcular" 
                                            className="p-button-warning p-button-text"
                                            onClick={this.calcularTempoTipoContribuicao}/>
                                    &nbsp;
                                    <Button label="Cadastrar" 
                                            className="p-button-success p-button-text"
                                            onClick={this.cadastrarTempoTipoContribuicao}/>
                                    &nbsp;
                                    <Button label="Cancelar" 
                                            className="p-button-secondary p-button-text"
                                            onClick={() => this.fecharModal('modalCalculo')}/>
                                  </div>
                                }
                                onHide={() => this.fecharModal('modalCalculo')}>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Data Base</label>
                             <InputMask id="dataBase" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text"
                                        mask="99/99/9999"
                                        value={this.state.dataBaseCalculo}
                                        onChange={e => this.setState({dataBaseCalculo: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Anos Comum</label>
                             <InputText id="anosComum" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.anosComum}
                                        onChange={e => this.setState({anosComum: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Meses Comum</label>
                             <InputText id="mesesComum" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.mesesComum}
                                        onChange={e => this.setState({mesesComum: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Dias Comum</label>
                             <InputText id="diasComum" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.diasComum}
                                        onChange={e => this.setState({diasComum: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Anos Especial</label>
                             <InputText id="anosEspecial" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.anosEspecial}
                                        onChange={e => this.setState({anosEspecial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Meses Especial</label>
                             <InputText id="mesesEspecial" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.mesesEspecial}
                                        onChange={e => this.setState({mesesEspecial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Dias Especial</label>
                             <InputText id="diasEspecial" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.diasEspecial}
                                        onChange={e => this.setState({diasEspecial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Anos Total</label>
                             <InputText id="anosTotal" 
                                        type="text" 
                                        disabled
                                        style={{width: '100%', height: '32px', backgroundColor: '#ccc'}}
                                        value={this.state.anosTotal}
                                        onChange={e => this.setState({anosTotal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Meses Total</label>
                             <InputText id="mesesTotal" 
                                        type="text" 
                                        disabled
                                        style={{width: '100%', height: '32px', backgroundColor: '#ccc'}}
                                        value={this.state.mesesTotal}
                                        onChange={e => this.setState({mesesTotal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Dias Total</label>
                             <InputText id="diasTotal" 
                                        disabled
                                        type="text" 
                                        style={{width: '100%', height: '32px', backgroundColor: '#ccc'}}
                                        value={this.state.diasTotal}
                                        onChange={e => this.setState({diasTotal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Fator Previdenciário</label>
                             <InputNumber inputId="fatorPrevidenciario" 
                                          value={this.state.fatorPrevidenciario} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({fatorPrevidenciario: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Simulação Resultado</label>
                             <InputNumber inputId="simulacaoResultado" 
                                          value={this.state.simulacaoResultado} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({simulacaoResultado: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Tipo de Aposentadoria</label>
                             <Dropdown value={this.state.tipoAposentadoria} style={{width: '100%', height: '32px'}} 
                                       options={this.tipoAposentadoria} style={{width: '100%', height: '32px'}}
                                       optionLabel="nome" 
                                       emptyMessage=" "
                                       filter showClear filterBy="nome"
                                       onChange={e => this.setState({tipoAposentadoria: e.target.value})}
                                       id="tipoAposentadoria"
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                      </Dialog>

                      {/**Cálculo por tipo de contribuição  - Alterar*/}
                      <Dialog header="Consultar cálculo tempo de contribuição"
                                visible={this.state.modalCalculoAlterar} 
                                style={{ width: '45vw' }} 
                                footer={
                                  <div>
                                    <Button label="Calcular" 
                                            className="p-button-warning p-button-text"
                                            onClick={this.calcularTempoTipoContribuicao}/>
                                    &nbsp;
                                    <Button label="Alterar" 
                                            className="p-button-success p-button-text"
                                            onClick={this.alterarCalculoTipoAposentadoria}/>
                                    &nbsp;
                                    <Button label="Cancelar" 
                                            className="p-button-secondary p-button-text"
                                            onClick={() => this.fecharModal('modalCalculoAlterar')}/>
                                  </div>
                                }
                                onHide={() => this.fecharModal('modalCalculoAlterar')}>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Data Base</label>
                             <InputMask id="dataBaseAlterar" 
                                        style={{width: '100%', height: '32px'}}
                                        type="text"
                                        mask="99/99/9999"
                                        value={this.state.dataBaseCalculo}
                                        onChange={e => this.setState({dataBaseCalculo: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Anos Comum</label>
                             <InputText id="anosComumAlterar" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.anosComum}
                                        onChange={e => this.setState({anosComum: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Meses Comum</label>
                             <InputText id="mesesComumAlterar" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.mesesComum}
                                        onChange={e => this.setState({mesesComum: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Dias Comum</label>
                             <InputText id="diasComumAlterar" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.diasComum}
                                        onChange={e => this.setState({diasComum: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Anos Especial</label>
                             <InputText id="anosEspecialAlterar" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.anosEspecial}
                                        onChange={e => this.setState({anosEspecial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Meses Especial</label>
                             <InputText id="mesesEspecialAlterrar" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.mesesEspecial}
                                        onChange={e => this.setState({mesesEspecial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Dias Especial</label>
                             <InputText id="diasEspecialAlterar" 
                                        type="text" 
                                        style={{width: '100%', height: '32px'}} 
                                        value={this.state.diasEspecial}
                                        onChange={e => this.setState({diasEspecial: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Anos Total</label>
                             <InputText id="anosTotalAlterar" 
                                        type="text" 
                                        disabled
                                        style={{width: '100%', height: '32px', backgroundColor: '#ccc'}}
                                        value={this.state.anosTotal}
                                        onChange={e => this.setState({anosTotal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Meses Total</label>
                             <InputText id="mesesTotalAlterar" 
                                        type="text" 
                                        disabled
                                        style={{width: '100%', height: '32px', backgroundColor: '#ccc'}}
                                        value={this.state.mesesTotal}
                                        onChange={e => this.setState({mesesTotal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Dias Total</label>
                             <InputText id="diasTotalAlterar" 
                                        disabled
                                        type="text" 
                                        style={{width: '100%', height: '32px', backgroundColor: '#ccc'}}
                                        value={this.state.diasTotal}
                                        onChange={e => this.setState({diasTotal: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Fator Previdenciário</label>
                             <InputNumber inputId="fatorPrevidenciarioAlterar" 
                                          value={this.state.fatorPrevidenciario} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({fatorPrevidenciario: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Simulação Resultado</label>
                             <InputNumber inputId="simulacaoResultadoAlterar" 
                                          value={this.state.simulacaoResultado} 
                                          style={{width: '100%', height: '32px'}} 
                                          onChange={(e) => this.setState({simulacaoResultado: e.value})} 
                                          mode="decimal" locale="de-BR" minFractionDigits={2}/>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div className="form-group">
                             <label>Tipo de Aposentadoria</label>
                             <Dropdown value={this.state.tipoAposentadoria} style={{width: '100%', height: '32px'}} 
                                       options={this.tipoAposentadoria} style={{width: '100%', height: '32px'}}
                                       optionLabel="nome" 
                                       emptyMessage=" "
                                       filter showClear filterBy="nome"
                                       onChange={e => this.setState({tipoAposentadoria: e.target.value})}
                                       id="tipoAposentadoriaAlterar"
                                       className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                      </Dialog>

                    </TabPanel>
                    <TabPanel header="Arquivos">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">  
                            <div className="container2">
                              
                              <Upload onUpload={this.handleUpload}/>
                              {!!upLoadFiles && (
                                <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                              )}
                            
                            </div>
                          </div>
                        </div>
                      </div>
                      <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                  currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                  emptyMessage="Nenhum Arquivo">
                        <Column field="arquivo" header="Arquivo"/>
                        <Column field="descricao" header="Descrição"></Column>
                        <Column field="usuario.nome" header="Usuário"></Column>
                        <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                      </DataTable> 
                      {/**Adicionar descrição ao arquivo */}
                      <Dialog header="Descrição do Arquivo"
                                  visible={this.state.modalDescricaoArquivo} 
                                  style={{ width: '40vw' }} 
                                  footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                                  onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                            <div className="row">
                              <div className="col-sm-12">
                                <div className="form-group">
                                  <label htmlFor="descricaoArquivo">Descrição</label>
                                  <InputText id="descricaoArquivo" 
                                        type="text" 
                                        style={{width: '100%', height: '37px'}} 
                                        value={this.state.descricao}
                                        onChange={e => this.setState({descricao: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                                </div>
                              </div>
                            </div>
                      </Dialog>
                    </TabPanel>
                    <TabPanel header="Atividades">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      data-toggle="modal" 
                                      onClick={this.novaAtividade}
                                      data-target="#modal-default">
                              <i className="fas fa-plus"></i> Criar Atividade</button>
                          </div>
                        </div>
                      </div>
                      <DataTable value={this.state.atividades}  paginator responsiveLayout="scroll"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                        size="small">
                        <Column body={this.linkConsultarAtividade} exportable={false} header="Atividade"></Column>
                        <Column body={this.statusTemplate} exportable={false} style={{ minWidth: '8rem' }}header="Status"></Column>
                        <Column field="subGrupo" header="Sub-Grupo"></Column>
                        <Column field="grupo" header="Grupo Trabalho"></Column>
                        <Column field="dataLimite" header="Data Limite"></Column>
                        <Column body={this.prazoFatal} exportable={false} header="Prazo Fatal"></Column>
                        <Column field="dataConcluido" header="Conclusão"></Column>
                        <Column field="responsaveis" header="Responsáveis"></Column>
                      </DataTable>
                      {/**Alterar Atividade */}
                      <Dialog header={
                        <div>
                          Atividade criada por:&nbsp;&nbsp;
                          <strong style={{color: '#ccc'}}>{this.state.usuarioCriouAtividade}&nbsp; em:&nbsp;
                            {this.state.dataRegistroAtividade}
                          </strong>
                        </div>
                      } autoComplete="nope"
                              visible={this.state.displayAtividade} 
                              style={{ width: '48vw' }}
                              footer={
                                <div className="left">
                                    <Button label="Alterar" 
                                            onClick={this.alterarAtividade}
                                            className="p-button-primary p-button-text"/>
                                    &nbsp;
                                    <Button label="Anexos" 
                                            icon="pi pi-paperclip"
                                            
                                            className="p-button-help p-button-text"/>
                                    &nbsp;
                                    <Button label="Novo Histórico" 
                                            icon="pi pi-history"
                                            className="p-button-help p-button-text"
                                            onClick={this.novoHistorico}/>
                                    &nbsp;
                                    <Button label="Cancelar" 
                                            className="p-button-secondary p-button-text"
                                            onClick={() => this.fecharModal('displayAtividade')}/>
                                </div>
                              } 
                              onHide={() => this.fecharModal('displayAtividade')}>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <h5><strong style={{color: '#000'}}>{this.state.tituloAtividade} - {this.state.pontuacao}</strong></h5>
                                <a style={{cursor: 'pointer'}}><Tag style={{background: 'linear-gradient(-225deg,#AC32E4 0%,#7918F2 48%,#4801FF 100%)', display: `${this.state.linkLancamento}`}}>
                                  <div className="flex align-items-center gap-2">
                                      <i className="pi pi-dollar"></i>
                                      <span className="text-base">Financeiro</span>
                                  </div>
                                </Tag>
                                </a>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group" style={{display: `${this.state.campoPessoaPesquisada}`}}>
                                <strong>Pessoa:&nbsp;&nbsp;{this.state.pessoaPesquisada}</strong>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <InputText id="grupoDescricao" 
                                          type="text" 
                                          disabled
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.grupoTrabalhoDescricao}
                                          onChange={e => this.setState({grupoTrabalhoDescricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <InputText id="subgrupoDescricao" 
                                          type="text" 
                                          disabled
                                          style={{width: '100%', height: '32px'}} 
                                          value={this.state.subGrupoTrabalhoDescricao}
                                          onChange={e => this.setState({subGrupoTrabalhoDescricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <MultiSelect inputId="multiselect" 
                                              value={this.state.responsaveisLista} 
                                              options={this.state.responsaveis} 
                                              style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                              onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                              filter showClear filterBy="nome"
                                              optionLabel="nome" 
                                              placeholder="Responsáveis"/>
                                <label className="linkCadGrupo">{this.state.quantidadeResponsaveis}</label>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <MultiSelect inputId="multiselect" 
                                              value={this.state.interessadosLista} 
                                              options={this.state.interessados} 
                                              style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                              onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                              filter showClear filterBy="nome"
                                              optionLabel="nome" 
                                              placeholder="Interssados"/>
                                <label className="linkCadGrupo">{this.state.quantidadeInteressados}</label>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-3">
                              <div className="form-group">
                                <Calendar id="mask" 
                                          value={this.state.dtLimite} 
                                          onChange={(e) => this.setState({ dtLimite: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"
                                          placeholder="Data Limite"/>
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <div className="form-group">
                              <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                          type="text"
                                          mask="99:99"
                                          value={this.state.hora}
                                          onChange={e => this.setState({hora: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Calendar id="mask" 
                                          value={this.state.dtFatal} 
                                          onChange={(e) => this.setState({ dtFatal: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"
                                          placeholder="Prazo fatal"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <InputTextarea value={this.state.descricaoAtividade} style={{width: '100%'}}
                                                id="descricaoE"
                                                onChange={e => this.setState({descricao: e.target.value})}
                                                rows={4} 
                                                cols={60} />
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <Dropdown value={this.state.status} style={{width: '100%', height: '32px'}} 
                                          options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                                          optionLabel="status" 
                                          emptyMessage=" "
                                          filter showClear filterBy="status"
                                          onChange={e => this.setState({status: e.target.value})}
                                          id="idStatusAtividade"
                                          className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                          </div>
                          <br></br>
                          <div className="row" style={{marginLeft: '12px'}}>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <label htmlFor="importante">
                                  <Checkbox inputId="importante" 
                                            name="importante" 
                                            value="importante"
                                            onChange={this.onGrauChange} 
                                            checked={this.state.grau.indexOf('importante') !== -1} />
                                  &nbsp;&nbsp;
                                  Importante
                                  &nbsp;&nbsp;
                                  <Checkbox inputId="urgente" 
                                            name="urgente" 
                                            value="urgente" 
                                            onChange={this.onGrauChange} 
                                            checked={this.state.grau.indexOf('urgente') !== -1} />
                                  &nbsp;&nbsp;
                                  Urgente
                                  &nbsp;&nbsp;
                                  <Checkbox inputId="privado" 
                                            name="privado" 
                                            value="privado" 
                                            onChange={this.onGrauChange} 
                                            checked={this.state.grau.indexOf('privado') !== -1} />
                                  &nbsp;&nbsp;
                                  Privado
                                </label>
                              </div>
                            </div>
                          </div>
                          <br></br>
                          <br></br>
                          <div className="row" style={{marginLeft: '12px'}}>
                            <div className="col-sm-12">
                              <div className="form-group">
                                <span style={{fontSize: '14px', fontWeight: 'bold'}}>Histórico</span>
                                <hr></hr>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <DataView value={this.state.historicoAtividades}
                                      layout="grid"
                                      emptyMessage=" "
                                      itemTemplate={this.templateHistoricoAtividade}/>
                              </div>
                            </div>
                          </div>
                      </Dialog>
                      {/**Incluir um novo histórico */}
                      <Dialog header="Incluir Histórico" autoComplete="nope"
                              style={{ width: '40vw' }} 
                              visible={this.state.displayHistoricoIncluir} 
                              footer={
                                <frameElement>
                                  <Button label="Incluir" 
                                          className="p-button-primary p-button-text"
                                          onClick={() => this.incluirHistorico()}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModalAtividade('displayHistoricoIncluir')}/>
                                </frameElement>
                                
                              } 
                              onHide={() => this.fecharModalAtividade('displayHistoricoIncluir')}> 

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <Editor value={this.state.dsHistorico} onTextChange={e => this.setState({dsHistorico: e.htmlValue})} style={{ height: '320px' }} />
                            </div>
                          </div>
                        </div>  
                      </Dialog>

                      {/**Alterar histórico */}
                      <Dialog header="Editar Histórico" autoComplete="nope"
                              style={{ width: '40vw' }} 
                              visible={this.state.modalAlterarHistorico} 
                              footer={
                                <frameElement>
                                  <Button label="Alterar" 
                                          className="p-button-primary p-button-text"
                                          onClick={this.alterarHistoricoAtividade}/>
                                  &nbsp;
                                  <Button label="Fechar" 
                                          className="p-button-secondary p-button-text"
                                          onClick={() => this.fecharModal('modalAlterarHistorico')}/>
                                </frameElement>
                                
                              } 
                              onHide={() => this.fecharModal('modalAlterarHistorico')}> 
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <Editor value={this.state.dsHistorico} onTextChange={e => this.setState({dsHistorico: e.htmlValue})} style={{ height: '320px' }} />
                            </div>
                          </div>
                        </div>  
                      </Dialog>
                      {/**Nova Atividade Pessoa */}
                      <Dialog header="Incluir Atividade"
                              visible={this.state.modalNovaAtividade}
                              style={{ width: '43vw' }}
                              footer={
                                <div className="left">
                                    <Button label="Cadastrar"
                                            className="p-button-primary p-button-text"
                                            onClick={this.cadastrarAtividade}/>
                                    &nbsp;
                                    <Button label="Anexar" 
                                            icon="pi pi-paperclip"
                                            onClick={() => this.abrirModalAnexo('displayAnexo')}
                                            className="p-button-help p-button-text"/>
                                    &nbsp;
                                    <Button label="Cancelar" 
                                            className="p-button-secondary p-button-text"
                                            onClick={() => this.fecharModal('modalNovaAtividade')}/>
                                </div>
                              } 
                              onHide={() => this.fecharModal('modalNovaAtividade')}>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <strong>{this.state.nome}</strong>
                              </div>
                            </div>
                          </div>
                          <br></br>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <Dropdown value={this.state.tituloAtividade} style={{width: '100%', height: '32px'}} 
                                          options={this.state.titulosAtividade} style={{width: '100%', height: '32px'}}
                                          optionLabel="tituloExibir" 
                                          filter showClear filterBy="tituloExibir"
                                          onChange={e => this.setState({tituloAtividade: e.target.value})}
                                          id="tituloAtividade"
                                          emptyMessage=" "
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          placeholder="Título de Atividade"/>
                                <a className="linkCadGrupo" 
                                  onClick={this.novoTituloAtividade} 
                                  style={{cursor: 'pointer', display: `${criaTitulo}`}}>Caso o título ainda não exista, crie clicando Aqui</a>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Dropdown value={this.state.grupoTrabalho} style={{width: '100%', height: '32px'}} 
                                          options={this.state.gruposTrabalho} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          filter showClear filterBy="nome"
                                          onChange={this.onGrupoTrabalhoUsuariosAtivosChange}
                                          id="grupoTrabalho"
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          placeholder="Grupo de Trabalho"/>
                                          <a onClick={this.novoGrupoTrabalho} style={{display: `${criaGrupo}`, cursor: 'pointer'}} className="linkCadGrupo">Caso o grupo ainda não exista, crie clicando Aqui</a>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Dropdown value={this.state.subGrupoTrabalho} style={{width: '100%', height: '32px'}} 
                                          options={this.state.subGruposTrabalho} style={{width: '100%', height: '32px'}}
                                          optionLabel="nome" 
                                          emptyMessage=" "
                                          filter showClear filterBy="nome"
                                          onChange={e => this.setState({subGrupoTrabalho: e.target.value})}
                                          id="subGrupoTrabalho"
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          placeholder="Sub-Grupo de Trabalho"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-6">
                              <div className="form-group">
                                <MultiSelect inputId="multiselect" 
                                            value={this.state.responsavel} 
                                            options={this.state.responsaveis} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ responsavel: e.value })} 
                                            filter showClear filterBy="nome"
                                            optionLabel="nome" 
                                            placeholder="Responsáveis"/>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <MultiSelect inputId="multiselect" 
                                            value={this.state.interessado} 
                                            options={this.state.interessados} 
                                            style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                            onChange={(e) => this.setState({ interessado: e.value })}  
                                            filter showClear filterBy="nome"
                                            optionLabel="nome" 
                                            placeholder="Interssados"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                              <Dropdown value={this.state.recorrencia} style={{width: '100%', height: '32px'}} 
                                        options={this.recorrencia} style={{width: '100%', height: '32px'}}
                                        optionLabel="nome" 
                                        emptyMessage=" "
                                        filter showClear filterBy="nome"
                                        onChange={(e) => this.setState({ recorrencia: e.value })}  
                                        id="recorrencia"
                                        className="p-inputtext-sm p-d-block p-mb-1"
                                        placeholder="Recorrência ?"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-3">
                              <div className="form-group">
                                <Calendar id="mask" 
                                          value={this.state.dtLimite} 
                                          onChange={(e) => this.setState({ dtLimite: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"
                                          placeholder="Data Limite"/>
                              </div>
                            </div>
                            <div className="col-sm-3">
                              <div className="form-group">
                              <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                        type="text"
                                        mask="99:99"
                                        value={this.state.hora}
                                        onChange={e => this.setState({hora: e.target.value})}
                                        className="p-inputtext-sm p-d-block p-mb-1"/>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <Calendar id="mask" 
                                          value={this.state.dtFatal} 
                                          onChange={(e) => this.setState({ dtFatal: e.value })} 
                                          locale="es"
                                          style={{width: '100%', height: '32px'}} 
                                          dateFormat="dd/mm/yy"
                                          mask="99/99/9999"
                                          placeholder="Prazo fatal"/>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <InputTextarea id="descricao" 
                                              type="text" 
                                              autoComplete="nope"
                                              style={{width: '100%'}} 
                                              value={this.state.descricao}
                                              onChange={e => this.setState({descricao: e.target.value})}
                                              className="p-inputtext-sm p-d-block p-mb-1"
                                              rows={3} cols={30}
                                              placeholder="Descrição da Atividade"/>
                              </div>
                            </div>
                          </div>
                          <br></br>
                          <div className="row" style={{marginLeft: '12px'}}>
                            <div className="col-sm-8">
                              <div className="form-group">
                                <label htmlFor="importante">
                                  <Checkbox inputId="importante" 
                                            name="importante" 
                                            value="importante" 
                                            onChange={this.onGrauChange} 
                                            checked={this.state.grau.indexOf('importante') !== -1} />
                                  &nbsp;&nbsp;
                                  Importante
                                  &nbsp;&nbsp;
                                  <Checkbox inputId="urgente" 
                                            name="urgente" 
                                            value="urgente" 
                                            onChange={this.onGrauChange} 
                                            checked={this.state.grau.indexOf('urgente') !== -1} />
                                  &nbsp;&nbsp;
                                  Urgente
                                  &nbsp;&nbsp;
                                  <Checkbox inputId="privado" 
                                            name="privado" 
                                            value="privado" 
                                            onChange={this.onGrauChange} 
                                            checked={this.state.grau.indexOf('privado') !== -1} />
                                  &nbsp;&nbsp;
                                  Privado
                                </label>
                              </div>
                            </div>
                          </div>
                      </Dialog>
                    </TabPanel>
                    <TabPanel header="Processos">
                      <DataTable value={this.state.processos}  paginator responsiveLayout="scroll"
                          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                          currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                          selectionMode="multiple">
                          <Column field="pasta" header="Pasta"></Column>
                          <Column field="nrProcesso" header="Processo Original"></Column>
                          <Column field="nrCnj" header="Numeração Única"></Column>
                          <Column field="montaPartes" header="Partes" style={{width: '300px'}}></Column>
                          <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
                          <Column field="dataUltimaMovimentacao" header="Últ. Mov."></Column>
                          <Column field="statusProcessual.descricao" header="Status Processual"></Column>
                          <Column body={this.acoesProcessos} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                        </DataTable>
                    </TabPanel>
                    <TabPanel header="Histórico">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      data-toggle="modal" 
                                      onClick={() => this.abrirModalHistorico('modalHistorico')}
                                      data-target="#modal-default">
                              <i className="fas fa-plus"></i> Adicionar</button>
                          </div>
                        </div>
                      </div>
                      <DataTable value={this.state.historico}  paginator responsiveLayout="scroll"
                                 size="small"
                                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                 currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                 selectionMode="multiple">
                          <Column field="dsHistorico" header="Histórico"></Column>
                          <Column field="dataHistorico" header="Data"></Column>
                          <Column field="tipo" header="Tipo"></Column>
                          <Column field="usuario.nome" header="Usuário"></Column>
                          <Column body={this.acoesHistorico} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                      {/**Adicionar histórico de pessoa manualmente */}
                      <Dialog header="Histórico da Pessoa"
                                  visible={this.state.modalHistorico} 
                                  style={{ width: '45vw' }} 
                                  footer={this.renderFooterHistorico('modalHistorico')}
                                  onHide={() => this.fecharModalCadastro('modalHistorico')}>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <InputTextarea id="pedidos" 
                                             type="text" 
                                             style={{width: '100%'}} 
                                             value={this.state.descricaoHistorico}
                                             onChange={e => this.setState({descricaoHistorico: e.target.value})}
                                             className="p-inputtext-sm p-d-block p-mb-1"
                                             rows={15} cols={30}/>
                            </div>
                          </div>
                        </div>
                              
                      </Dialog>
                    </TabPanel>
                  </TabView>
                </div>
              </div>
              <div className="card">
                <div className="row">
                  <div className="col-sm-11">
                    <div className="form-group">
                      <div style={{textAlign: 'right'}}>
                        <Button label="Alterar" 
                                className="p-button-primary p-button-text"
                                onClick={this.alterarPessoa}/>
                        &nbsp;
                        <Button label="Voltar" 
                            className="p-button-secondary p-button-text"
                            onClick={this.voltar}/>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </>
    )
  }
}
ConsultarPessoa.contextType = AuthContext;
export default withRouter(ConsultarPessoa)
